<!-- package-management.component.html -->
<div class="container mx-auto p-8">

  <!-- MENÚ PRINCIPAL -->
  <div *ngIf="currentView === 'menu'" class="mt-24">
    <h1 class="text-3xl font-bold mb-8">Gestión de Paquetes</h1>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
      <!-- Empaquetado -->
      <button
        class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer w-full text-left"
        (click)="startEmpaquetado()">
        <div class="flex items-center mb-4">
          <i class="fas fa-box text-3xl text-blue-500 mr-4"></i>
          <h2 class="text-xl font-semibold">Empaquetado</h2>
        </div>
        <p class="text-gray-600">Ver paquetes empaquetados y escanear para procesar</p>
      </button>

      <!-- Cargado al Camión -->
      <button
        class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer w-full text-left"
        (click)="startCargado()">
        <div class="flex items-center mb-4">
          <i class="fas fa-shipping-fast text-3xl text-purple-500 mr-4"></i>
          <h2 class="text-xl font-semibold">Cargado al Camión</h2>
        </div>
        <p class="text-gray-600">Ver paquetes cargados y escanear para procesar</p>
      </button>

      <!-- Enviado -->
      <button
        class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer w-full text-left"
        (click)="startEnviado()">
        <div class="flex items-center mb-4">
          <i class="fas fa-truck text-3xl text-green-500 mr-4"></i>
          <h2 class="text-xl font-semibold">Enviado al Taller</h2>
        </div>
        <p class="text-gray-600">Ver paquetes enviados y escanear para procesar</p>
      </button>

      <!-- Gestionar Existentes -->
      <button
        class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer w-full text-left"
        (click)="showManageExisting()">
        <div class="flex items-center mb-4">
          <i class="fas fa-cogs text-3xl text-indigo-500 mr-4"></i>
          <h2 class="text-xl font-semibold">Gestionar Existentes</h2>
        </div>
        <p class="text-gray-600">Administrar paquetes existentes, expandir y editar</p>
      </button>

      <!-- Historial -->
      <button
        class="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow cursor-pointer w-full text-left"
        (click)="showHistorial()">
        <div class="flex items-center mb-4">
          <i class="fas fa-history text-3xl text-orange-500 mr-4"></i>
          <h2 class="text-xl font-semibold">Historial</h2>
        </div>
        <p class="text-gray-600">Ver, editar y eliminar listas de paquetes</p>
      </button>
    </div>
  </div>

  <!-- VISTA EMPAQUETADO -->
  <div *ngIf="currentView === 'empaquetado'" class="mt-24">
    <span (click)="showMenu()"
      class="inline-flex items-center text-blue-600 hover:text-blue-800 cursor-pointer mb-4 text-lg font-medium">
      <i class="fas fa-arrow-left mr-2"></i>Volver atrás
    </span>
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Empaquetado - Gestión de Paquetes</h1>
      <div class="flex space-x-3">
        <button (click)="forceReloadPackages()" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-sync-alt mr-2"></i>Recargar
        </button>
        <button (click)="showMenu()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-arrow-left mr-2"></i>Volver al Menú
        </button>
      </div>
    </div>

    <!-- SECCIÓN DE ESCANEO DE PAQUETES PENDIENTES -->
    <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
      <h2 class="text-xl font-semibold mb-4 text-blue-600">
        <i class="fas fa-qr-code-scan mr-2"></i>Escanear Paquetes Pendientes
      </h2>
      <p class="text-gray-600 mb-4">Escanea paquetes pendientes para agregarlos a la lista de empaquetado</p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Input para escanear paquete -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Número de Paquete</label>
          <div class="flex">
            <input type="text" [(ngModel)]="pendingPackageToScan" (ngModelChange)="onPendingPackageToScanChange()"
              placeholder="Escanea o ingresa el número de paquete"
              class="flex-1 rounded-l-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              (keyup.enter)="scanPendingPackage()">
            <button (click)="scanPendingPackage()" [disabled]="!pendingPackageToScan?.trim() || scanningPendingPackage"
              class="bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 text-white px-4 py-2 rounded-r-md transition-colors">
              <span *ngIf="scanningPendingPackage"
                class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></span>
              <i *ngIf="!scanningPendingPackage" class="fas fa-search mr-2"></i>
              {{ scanningPendingPackage ? 'Escaneando...' : 'Escanear' }}
            </button>
          </div>
        </div>

        <!-- Información del paquete escaneado -->
        <div *ngIf="scannedPendingPackageInfo" class="bg-blue-50 border border-blue-200 rounded-md p-4">
          <h4 class="font-medium text-blue-800 mb-2">Paquete Encontrado</h4>
          <p class="text-sm text-blue-700"><strong>Número:</strong> {{ scannedPendingPackageInfo.packageNumber }}</p>
          <p class="text-sm text-blue-700"><strong>Orden:</strong> {{ scannedPendingPackageInfo.orderNumber }}</p>
          <p class="text-sm text-blue-700"><strong>Repuestos:</strong> {{ scannedPendingPackageInfo.sparePartsCount }}
          </p>
          <p class="text-sm text-blue-600 mt-2">
            <i class="fas fa-info-circle mr-1"></i>
            El paquete será agregado automáticamente a la lista de empaquetado
          </p>
        </div>
      </div>

      <!-- Mensaje de estado -->
      <div *ngIf="pendingPackageMessage && !showPackagingConfirmationModal" class="mt-3">
        <div [class]="pendingPackageMessageType === 'error' ? 'text-red-600' : 'text-green-600'" class="text-sm">
          <i [class]="pendingPackageMessageType === 'error' ? 'fas fa-exclamation-circle' : 'fas fa-check-circle'"
            class="mr-2"></i>
          {{ pendingPackageMessage }}
        </div>
      </div>
    </div>

    <!-- Loading spinner -->
    <div *ngIf="loading" class="flex justify-center items-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      <span class="ml-2 text-gray-600">Cargando paquetes empaquetados...</span>
    </div>

    <!-- Lista de paquetes únicos -->
    <div *ngIf="!loading && uniquePackages.length > 0" class="space-y-4">
      <div class="bg-white p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold mb-4">Paquetes Empaquetados</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div *ngFor="let package of uniquePackages"
            class="p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
            (click)="viewUniquePackageDetails(package)">
            <div class="flex justify-between items-start">
              <div class="flex-1">
                <h3 class="font-medium text-gray-900">{{ package.packageNumber }}</h3>
                <p class="text-sm text-gray-600">Orden: {{ package.orderNumber }}</p>
                <p class="text-sm text-gray-600">Creado: {{ package.createdAt | date:'short' }}</p>
                <div class="flex items-center space-x-2 mt-2">
                  <span class="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                    {{ package.sparePartsCount }} repuestos
                  </span>
                  <span class="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">
                    Empaquetado
                  </span>
                </div>
              </div>
              <div class="flex space-x-2">
                <button (click)="reprintPackageLabel(package); $event.stopPropagation()"
                  class="text-purple-600 hover:text-purple-800 p-1" title="Reimprimir etiqueta del paquete">
                  <i class="fas fa-tag"></i>
                </button>
                <button (click)="viewUniquePackageDetails(package); $event.stopPropagation()"
                  class="text-blue-600 hover:text-blue-800 p-1" title="Ver detalles del paquete">
                  <i class="fas fa-eye"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensaje cuando no hay paquetes -->
    <div *ngIf="!loading && existingPackages.length === 0" class="text-center py-8">
      <i class="fas fa-box-open text-4xl text-gray-400 mb-4"></i>
      <h3 class="text-lg font-medium text-gray-900 mb-2">No hay paquetes empaquetados</h3>
      <p class="text-gray-600 mb-4">Los paquetes aparecerán aquí una vez que se generen etiquetas y se empaqueten
        repuestos desde el historial de órdenes.</p>
      <p class="text-sm text-gray-500">Para crear paquetes empaquetados, ve al historial de órdenes y genera etiquetas
        para una orden.</p>
    </div>

    <!-- Modal de detalles de paquete -->
    <div *ngIf="showPackageDetailsModal && currentView === 'empaquetado'"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      (click)="closePackageDetailsModal()">
      <div class="bg-white rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden"
        (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center p-6 border-b">
          <div>
            <h3 class="text-xl font-bold">{{selectedPackageForView?.name}}</h3>
            <p class="text-sm text-gray-600">Número de Paquete: {{selectedPackageForView?.items[0].packageNumber ||
              'N/A'}}</p>
          </div>
          <div class="flex items-center space-x-3">
            <button (click)="closePackageDetailsModal()" class="text-gray-500 hover:text-gray-700 p-2">
              <i class="fas fa-times text-xl"></i>
            </button>
          </div>
        </div>

        <div class="p-6 overflow-auto max-h-[calc(90vh-120px)]">

          <div *ngIf="selectedPackageForView?.items && selectedPackageForView.items.length > 0" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50 sticky top-0">
                <tr>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Posición</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Repuesto</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nº Paquete</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Orden</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Taller</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Escaneado</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                  <!-- Header de Acciones eliminado - solo se permite desarmar paquete completo -->
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <!-- DEBUG: Total items: {{selectedPackageForView?.items?.length}} -->
                <tr *ngFor="let item of selectedPackageForView.items; let i = index; trackBy: trackBySparePartId"
                  class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{item.position}} ({{i}})
                  </td>
                  <td class="px-6 py-4">
                    <div class="font-medium text-gray-900">{{item.sparePartName}}</div>
                    <div class="text-sm text-blue-600" *ngIf="item.sparePartNameEs">🇪🇸 {{item.sparePartNameEs}}</div>
                    <div class="text-sm text-green-600" *ngIf="item.sparePartNamePt">🇧🇷 {{item.sparePartNamePt}}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.productCode}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.packageNumber || 'N/A'}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.orderNumber || 'N/A'}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full"
                      [ngClass]="getWorkshopBadgeClass(item.workshopId)">
                      {{getWorkshopName(item.workshopId)}}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.scannedAt | date:'dd/MM/yyyy HH:mm'}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
                      {{item.itemStatus | titlecase}}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <!-- Botón de eliminación individual removido - solo se permite desarmar paquete completo -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="!selectedPackageForView?.items || selectedPackageForView.items.length === 0"
            class="text-gray-500 text-center py-8">
            <i class="fas fa-box-open text-4xl mb-4"></i>
            <p>Este paquete no tiene repuestos asociados.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- VISTA PREVIA CARGADO AL CAMIÓN -->
  <div *ngIf="showCargadoPreview" class="mt-24">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold text-purple-600">
        <i class="fas fa-truck mr-2"></i>Cargado al Camión - Vista Previa
      </h1>
      <button (click)="showMenu()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
        <i class="fas fa-arrow-left mr-2"></i>Volver al Menú
      </button>
    </div>

    <!-- Botón para iniciar nueva carga -->
    <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
      <div class="text-center">
        <h2 class="text-xl font-semibold mb-4 text-purple-600">
          <i class="fas fa-plus-circle mr-2"></i>Nueva Carga al Camión
        </h2>
        <p class="text-gray-600 mb-4">Inicia el proceso de carga de nuevos paquetes al camión</p>
        <button (click)="iniciarNuevaCarga()"
          class="bg-purple-500 hover:bg-purple-600 text-white px-6 py-3 rounded-lg text-lg font-semibold transition-colors shadow-lg hover:shadow-xl">
          <i class="fas fa-truck mr-2"></i>Cargar Nuevo Paquete
        </button>
      </div>
    </div>

    <!-- Listas separadas por tipo de vehículo -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- Lista de paquetes cargados en CAMIÓN -->
      <div class="bg-white p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold mb-4 text-blue-600">
          <i class="fas fa-truck mr-2"></i>Paquetes en Camión
        </h2>

        <!-- Loading spinner -->
        <div *ngIf="loadingPaquetesEnCamion" class="flex justify-center items-center py-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span class="ml-2 text-gray-600">Cargando paquetes en camión...</span>
        </div>

        <!-- Lista de paquetes en camión -->
        <div *ngIf="!loadingPaquetesEnCamion && getPaquetesByVehicleType('camion').length > 0" class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-blue-50">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Paquete</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orden</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Repuestos
                </th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha Carga
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let paquete of getPaquetesByVehicleType('camion')" class="hover:bg-blue-50">
                <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <div class="flex items-center">
                    <i class="fas fa-truck text-blue-500 mr-2"></i>
                    {{ paquete.packageNumber }}
                  </div>
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ paquete.orden || 'N/A' }}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ paquete.totalRepuestos || 'N/A' }}
                </td>
                <td class="px-4 py-4 whitespace-nowrap">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    <i class="fas fa-check mr-1"></i>Cargado en Camión
                  </span>
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ paquete.fecha | date:'dd/MM/yyyy HH:mm' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mensaje cuando no hay paquetes en camión -->
        <div *ngIf="!loadingPaquetesEnCamion && getPaquetesByVehicleType('camion').length === 0"
          class="text-center py-8">
          <div class="text-gray-500">
            <i class="fas fa-truck text-4xl mb-4 block text-blue-400"></i>
            <p class="text-lg">No hay paquetes cargados en camión</p>
            <p class="text-sm">Haz clic en "Cargar Nuevo Paquete" para comenzar</p>
          </div>
        </div>
      </div>

      <!-- Lista de paquetes cargados en CAMIONETA -->
      <div class="bg-white p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold mb-4 text-green-600">
          <i class="fas fa-truck-pickup mr-2"></i>Paquetes en Camioneta
        </h2>

        <!-- Loading spinner -->
        <div *ngIf="loadingPaquetesEnCamion" class="flex justify-center items-center py-8">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
          <span class="ml-2 text-gray-600">Cargando paquetes en camioneta...</span>
        </div>

        <!-- Lista de paquetes en camioneta -->
        <div *ngIf="!loadingPaquetesEnCamion && getPaquetesByVehicleType('camioneta').length > 0"
          class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-green-50">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Paquete</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orden</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Repuestos
                </th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha Carga
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let paquete of getPaquetesByVehicleType('camioneta')" class="hover:bg-green-50">
                <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <div class="flex items-center">
                    <i class="fas fa-truck-pickup text-green-500 mr-2"></i>
                    {{ paquete.packageNumber }}
                  </div>
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ paquete.orden || 'N/A' }}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ paquete.totalRepuestos || 'N/A' }}
                </td>
                <td class="px-4 py-4 whitespace-nowrap">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <i class="fas fa-check mr-1"></i>Cargado en Camioneta
                  </span>
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ paquete.fecha | date:'dd/MM/yyyy HH:mm' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mensaje cuando no hay paquetes en camioneta -->
        <div *ngIf="!loadingPaquetesEnCamion && getPaquetesByVehicleType('camioneta').length === 0"
          class="text-center py-8">
          <div class="text-gray-500">
            <i class="fas fa-truck-pickup text-4xl mb-4 block text-green-400"></i>
            <p class="text-lg">No hay paquetes cargados en camioneta</p>
            <p class="text-sm">Haz clic en "Cargar Nuevo Paquete" para comenzar</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- VISTA ENVIADO -->
  <div *ngIf="currentView === 'enviado'" class="mt-24">
    <span (click)="showMenu()"
      class="inline-flex items-center text-blue-600 hover:text-blue-800 cursor-pointer mb-4 text-lg font-medium">
      <i class="fas fa-arrow-left mr-2"></i>Volver atrás
    </span>
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Enviado al Taller - Gestión de Paquetes</h1>
      <div class="flex space-x-3">
        <button (click)="forceReloadPackages()" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-sync-alt mr-2"></i>Recargar
        </button>
        <button (click)="showMenu()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-arrow-left mr-2"></i>Volver al Menú
        </button>
      </div>
    </div>


    <div class="bg-white p-4 rounded-lg shadow-lg mb-4">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Enviado desde</label>
          <input
            type="datetime-local"
            [(ngModel)]="enviadoSentFrom"
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Enviado hasta</label>
          <input
            type="datetime-local"
            [(ngModel)]="enviadoSentTo"
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500">
        </div>
        <button
          (click)="applyEnviadoDateTimeFilter()"
          class="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-filter mr-2"></i>Aplicar filtro
        </button>
        <button
          (click)="clearEnviadoDateTimeFilter()"
          class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-eraser mr-2"></i>Limpiar
        </button>
      </div>
    </div>

    <!-- Loading spinner -->
    <div *ngIf="loading" class="flex justify-center items-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
      <span class="ml-2 text-gray-600">Cargando paquetes enviados...</span>
    </div>

    <!-- Formulario de Escaneo - SIEMPRE ARRIBA para fácil acceso -->
    <div class="mb-4">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-2xl mx-auto">
        <h2 class="text-xl font-semibold mb-4">Escanear Paquete para Envío al Taller</h2>
        <form [formGroup]="scanForm" (ngSubmit)="onScanSubmit()" class="flex gap-4">
          <input type="text" formControlName="scannedCode" (input)="onScannedCodeInput($event)"
            placeholder="Escanee número de paquete (E2024001-PAC0001)"
            class="flex-1 rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500">
          <button type="submit" [disabled]="isScanning"
            class="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-md disabled:bg-gray-400">
            <i class="fas fa-barcode mr-2" *ngIf="!isScanning"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="isScanning"></i>
            {{isScanning ? 'Procesando...' : 'Escanear Paquete'}}
          </button>
        </form>
        <div class="mt-3 text-sm text-gray-600">
          <i class="fas fa-info-circle mr-1"></i>
          <strong>Solo números de paquete:</strong> El paquete debe existir y estar en estado "Cargado al Camión" para
          poder enviarlo al taller
        </div>
      </div>
    </div>

    <!-- Lista de paquetes únicos -->
    <div *ngIf="!loading && uniquePackages.length > 0" class="space-y-4">
      <div class="bg-white p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-semibold mb-4">Paquetes Enviados al Taller</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div *ngFor="let package of uniquePackages"
            class="p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
            (click)="viewUniquePackageDetails(package)">
            <div class="flex justify-between items-start">
              <div class="flex-1">
                <h3 class="font-medium text-gray-900">{{ package.packageNumber }}</h3>
                <p class="text-sm text-gray-600">Orden: {{ package.orderNumber }}</p>
                <p class="text-sm text-gray-600">Enviado: {{ (package.sentAt || package.createdAt) | date:'dd/MM/yyyy HH:mm' }}</p>
                <div class="flex items-center space-x-2 mt-2">
                  <span class="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">
                    {{ package.sparePartsCount }} repuestos
                  </span>
                  <span class="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">
                    Enviado al Taller
                  </span>
                </div>
              </div>
              <button (click)="viewUniquePackageDetails(package); $event.stopPropagation()"
                class="text-green-600 hover:text-green-800 p-1" title="Ver detalles del paquete">
                <i class="fas fa-eye"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensaje cuando no hay paquetes -->
    <div *ngIf="!loading && existingPackages.length === 0" class="text-center py-8">
      <i class="fas fa-truck text-4xl text-gray-400 mb-4"></i>
      <h3 class="text-lg font-medium text-gray-900 mb-2">No hay paquetes enviados</h3>
      <p class="text-gray-600 mb-4">Los paquetes aparecerán aquí una vez que se procesen envíos al taller.</p>
    </div>

    <!-- Modal de detalles de paquete para enviado al taller -->
    <div *ngIf="showPackageDetailsModal && currentView === 'enviado'"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      (click)="closePackageDetailsModal()">
      <div class="bg-white rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden"
        (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center p-6 border-b">
          <div>
            <h3 class="text-xl font-bold">{{generateEnviadoPackageTitle(selectedPackageForView)}}</h3>
            <p class="text-sm text-gray-600">Número de Paquete: {{selectedPackageForView?.items[0].packageNumber ||
              'N/A'}}</p>
          </div>
          <div class="flex items-center space-x-3">
            <!-- Botón para volver atrás a estado anterior - Mostrar si hay repuestos ENVIADOS -->
            <button *ngIf="selectedPackageForView?.status !== 'completed' && hasEnviadoSpareParts()"
              (click)="revertPackageToPreviousState(selectedPackageForView?.items[0].packageNumber || '')"
              class="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md text-sm"
              title="Revertir paquete enviado a estado anterior">
              <i class="fas fa-undo mr-2"></i>Volver Atrás
            </button>
            <!-- Solo mostrar el botón de agregar repuesto si el paquete no está completado -->
            <button *ngIf="selectedPackageForView?.status !== 'completed'"
              (click)="openAddSparePartToPackageModal(selectedPackageForView?.items[0].packageNumber || '')"
              class="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm">
              <i class="fas fa-plus mr-2"></i>Agregar Repuesto
            </button>
            <button (click)="closePackageDetailsModal()" class="text-gray-500 hover:text-gray-700 p-2">
              <i class="fas fa-times text-xl"></i>
            </button>
          </div>
        </div>

        <div class="p-6 overflow-auto max-h-[calc(90vh-120px)]">

          <div *ngIf="selectedPackageForView?.items && selectedPackageForView.items.length > 0" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50 sticky top-0">
                <tr>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Posición</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Repuesto</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nº Paquete</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Orden</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Escaneado</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr *ngFor="let item of selectedPackageForView.items" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{item.position}}
                  </td>
                  <td class="px-6 py-4">
                    <div class="font-medium text-gray-900">{{item.sparePartName}}</div>
                    <div class="text-sm text-blue-600" *ngIf="item.sparePartNameEs">🇪🇸 {{item.sparePartNameEs}}</div>
                    <div class="text-sm text-green-600" *ngIf="item.sparePartNamePt">🇧🇷 {{item.sparePartNamePt}}</div>
                    <div class="text-sm text-gray-500" *ngIf="item.remitoNumber">Remito: {{item.remitoNumber}}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.productCode}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.packageNumber}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.orderNumber}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.scannedAt | date:'short'}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span class="px-2 py-1 text-xs font-medium rounded-full" [ngClass]="{
                            'bg-yellow-100 text-yellow-800': item.itemStatus === 'scanned',
                            'bg-blue-100 text-blue-800': item.itemStatus === 'to_load',
                            'bg-green-100 text-green-800': item.itemStatus === 'checked',
                            'bg-purple-100 text-purple-800': item.itemStatus === 'completed'
                          }">
                      {{item.itemStatus}}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <!-- Botón de eliminación individual removido - solo se permite desarmar paquete completo -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="!selectedPackageForView?.items || selectedPackageForView.items.length === 0"
            class="text-center py-8 text-gray-500">
            No hay repuestos en este paquete
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- VISTA CARGADO AL CAMIÓN -->
  <div *ngIf="currentView === 'cargado'" class="mt-24">
    <span (click)="showMenu()"
      class="inline-flex items-center text-blue-600 hover:text-blue-800 cursor-pointer mb-4 text-lg font-medium">
      <i class="fas fa-arrow-left mr-2"></i>Volver atrás
    </span>
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Cargado al Camión - Gestión de Paquetes</h1>
      <div class="flex space-x-3">
        <button (click)="forceReloadPackages()" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-sync-alt mr-2"></i>Recargar
        </button>
        <button (click)="showMenu()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-arrow-left mr-2"></i>Volver al Menú
        </button>
      </div>
    </div>

    <!-- BOTÓN PARA INICIAR CARGAMENTO -->
    <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
      <div class="text-center">
        <h2 class="text-xl font-semibold mb-4 text-purple-600">
          <i class="fas fa-truck mr-2"></i>Nuevo Cargamento
        </h2>
        <p class="text-gray-600 mb-6">Inicia un nuevo proceso de carga de paquetes al camión</p>
        <div class="flex gap-4">
          <button (click)="iniciarNuevaCarga()"
            class="bg-purple-500 hover:bg-purple-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors shadow-lg hover:shadow-xl">
            <i class="fas fa-play mr-2"></i>Iniciar Nuevo Cargamento
          </button>

        </div>
      </div>
    </div>

    <!-- HISTORIAL DE CARGAMENTOS SEPARADO POR TIPO DE VEHÍCULO -->
    <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
      <div class="flex justify-between items-center mb-4">
        <div>
          <h2 class="text-xl font-semibold text-gray-800">
            <i class="fas fa-truck mr-2"></i>Paquetes Cargados al Camión
          </h2>
          <p class="text-gray-600 text-sm">Todos los paquetes que han sido cargados al camión o camioneta</p>
        </div>
      </div>

      <!-- Buscador -->
      <div class="mb-6">
        <div class="relative">
          <input type="text" [(ngModel)]="searchTermCargado"
            placeholder="Buscar por número de paquete, orden o nombre..."
            class="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500">
          <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
          <button *ngIf="searchTermCargado" (click)="searchTermCargado = ''"
            class="absolute right-3 top-3 text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Loading spinner para historial -->
      <div *ngIf="loadingHistorial" class="flex justify-center items-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
        <span class="ml-2 text-gray-600">Cargando paquetes cargados...</span>
      </div>

      <!-- Listas en dos columnas: Camión y Camioneta -->
      <div *ngIf="!loadingHistorial && historialCargamentos.length > 0" class="grid grid-cols-1 lg:grid-cols-2 gap-6">

        <!-- COLUMNA IZQUIERDA: Paquetes en Camión -->
        <div class="bg-purple-50 rounded-lg p-4 border-l-4 border-purple-500">
          <h3 class="text-lg font-semibold text-purple-700 mb-4 flex items-center">
            <i class="fas fa-truck mr-2 text-xl"></i>
            <span>Camion 🚛</span>
            <span class="ml-2 px-2 py-1 bg-purple-200 text-purple-800 rounded-full text-sm font-medium">
              {{ getPaquetesByVehicleType('camion').length }}
            </span>
          </h3>

          <div *ngIf="getPaquetesByVehicleType('camion').length === 0"
            class="text-center py-8 text-gray-500 rounded-lg">
            <i class="fas fa-truck text-4xl mb-3 text-purple-300"></i>
            <p class="font-medium">No hay paquetes cargados en camión</p>
            <p class="text-xs text-gray-400 mt-1">Los nuevos paquetes aparecerán aquí después de exportarlos</p>
          </div>

          <div *ngIf="getPaquetesByVehicleType('camion').length > 0"
            class="space-y-3 max-h-[calc(100vh-400px)] overflow-y-auto pr-2">
            <div *ngFor="let paquete of getPaquetesByVehicleType('camion')"
              class="bg-white p-4 rounded-lg border border-purple-200 cursor-pointer hover:bg-purple-50 hover:shadow-md transition-all"
              (click)="viewPackageHistoryDetails(paquete)">
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <div class="flex items-center mb-2">
                    <i class="fas fa-truck mr-2 text-purple-600"></i>
                    <h4 class="font-semibold text-gray-800">{{ paquete.packageNumber }}</h4>
                    <span
                      class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      <i class="fas fa-check-circle mr-1"></i>
                      {{ paquete.estado }}
                    </span>
                  </div>

                  <p class="text-sm text-gray-600 mb-3">{{ paquete.packageName }}</p>

                  <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <div>
                      <span class="text-gray-600">Orden:</span>
                      <p class="font-medium">{{ paquete.orden || 'N/A' }}</p>
                    </div>
                    <div>
                      <span class="text-gray-600">Fecha:</span>
                      <p class="font-medium">{{ paquete.fecha ? (paquete.fecha | date:'dd/MM/yyyy HH:mm') : 'Sin fecha' }}</p>
                    </div>
                    <div>
                      <span class="text-gray-600">Cargados:</span>
                      <p class="font-medium text-green-600">{{ paquete.repuestosCargados }}</p>
                    </div>
                    <div>
                      <span class="text-gray-600">Total:</span>
                      <p class="font-medium text-blue-600">{{ paquete.totalRepuestos }}</p>
                    </div>
                  </div>

                  <!-- Indicador de click -->
                  <div class="mt-3 flex items-center text-purple-600 text-sm">
                    <i class="fas fa-eye mr-1"></i>
                    <span>Haz clic para ver los repuestos</span>
                  </div>
                </div>
                <div class="ml-4">
                  <i class="fas fa-chevron-right text-purple-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- COLUMNA DERECHA: Paquetes en Camioneta -->
        <div class="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
          <h3 class="text-lg font-semibold text-blue-700 mb-4 flex items-center">
            <i class="fas fa-truck-pickup mr-2 text-xl"></i>
            <span>Camioneta</span>
            <img src="/assets/images/pickup-car.png" alt="Camioneta"
              style="width: 24px; height: 24px; display: inline-block; vertical-align: middle; margin-left: 4px;" />
            <span class="ml-2 px-2 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium">
              {{ getPaquetesByVehicleType('camioneta').length }}
            </span>
          </h3>

          <div *ngIf="getPaquetesByVehicleType('camioneta').length === 0"
            class="text-center py-8 text-gray-500 rounded-lg">
            <i class="fas fa-truck-pickup text-4xl mb-3 text-blue-300"></i>
            <p class="font-medium">No hay paquetes cargados en camioneta</p>
            <p class="text-xs text-gray-400 mt-1">Los nuevos paquetes aparecerán aquí después de exportarlos</p>
          </div>

          <div *ngIf="getPaquetesByVehicleType('camioneta').length > 0"
            class="space-y-3 max-h-[calc(100vh-400px)] overflow-y-auto pr-2">
            <div *ngFor="let paquete of getPaquetesByVehicleType('camioneta')"
              class="bg-white p-4 rounded-lg border border-blue-200 cursor-pointer hover:bg-blue-50 hover:shadow-md transition-all"
              (click)="viewPackageHistoryDetails(paquete)">
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <div class="flex items-center mb-2">
                    <i class="fas fa-truck-pickup mr-2 text-blue-600"></i>
                    <h4 class="font-semibold text-gray-800">{{ paquete.packageNumber }}</h4>
                    <span
                      class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      <i class="fas fa-check-circle mr-1"></i>
                      {{ paquete.estado }}
                    </span>
                  </div>

                  <p class="text-sm text-gray-600 mb-3">{{ paquete.packageName }}</p>

                  <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <div>
                      <span class="text-gray-600">Orden:</span>
                      <p class="font-medium">{{ paquete.orden || 'N/A' }}</p>
                    </div>
                    <div>
                      <span class="text-gray-600">Fecha:</span>
                      <p class="font-medium">{{ paquete.fecha ? (paquete.fecha | date:'dd/MM/yyyy HH:mm') : 'Sin fecha' }}</p>
                    </div>
                    <div>
                      <span class="text-gray-600">Cargados:</span>
                      <p class="font-medium text-green-600">{{ paquete.repuestosCargados }}</p>
                    </div>
                    <div>
                      <span class="text-gray-600">Total:</span>
                      <p class="font-medium text-blue-600">{{ paquete.totalRepuestos }}</p>
                    </div>
                  </div>

                  <!-- Indicador de click -->
                  <div class="mt-3 flex items-center text-blue-600 text-sm">
                    <i class="fas fa-eye mr-1"></i>
                    <span>Haz clic para ver los repuestos</span>
                  </div>
                </div>
                <div class="ml-4">
                  <i class="fas fa-chevron-right text-blue-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mensaje cuando no hay historial -->
      <div *ngIf="!loadingHistorial && historialCargamentos.length === 0" class="text-center py-8">
        <i class="fas fa-shipping-fast text-4xl text-gray-400 mb-4"></i>
        <h3 class="text-lg font-medium text-gray-900 mb-2">No hay paquetes cargados</h3>
        <p class="text-gray-600">Los paquetes aparecerán aquí una vez que se procesen cargas al camión.</p>
      </div>
    </div>

    <!-- Loading spinner -->
    <div *ngIf="loading" class="flex justify-center items-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
      <span class="ml-2 text-gray-600">Cargando paquetes cargados...</span>
    </div>

    <!-- Lista de paquetes únicos -->
    <!-- Los paquetes cargados ahora se muestran en el historial unificado -->


    <!-- Modal de detalles de paquete para cargado al camión -->
    <div *ngIf="showPackageDetailsModal && currentView === 'cargado'"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      (click)="closePackageDetailsModal()">
      <div class="bg-white rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden"
        (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center p-6 border-b">
          <div>
            <h3 class="text-xl font-bold">{{generateCargadoPackageTitle(selectedPackageForView)}}</h3>
            <p class="text-sm text-gray-600">Número de Paquete: {{selectedPackageForView?.items[0].packageNumber ||
              'N/A'}}</p>
          </div>
          <div class="flex items-center space-x-3">
            <!-- Solo mostrar el botón de agregar repuesto si el paquete no está completado -->
            <button *ngIf="selectedPackageForView?.status !== 'completed'"
              (click)="openAddSparePartToPackageModal(selectedPackageForView?.items[0].packageNumber || '')"
              class="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-md text-sm">
              <i class="fas fa-plus mr-2"></i>Agregar Repuesto
            </button>
            <button (click)="closePackageDetailsModal()" class="text-gray-500 hover:text-gray-700 p-2">
              <i class="fas fa-times text-xl"></i>
            </button>
          </div>
        </div>

        <div class="p-6 overflow-auto max-h-[calc(90vh-120px)]">

          <div *ngIf="selectedPackageForView?.items && selectedPackageForView.items.length > 0" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50 sticky top-0">
                <tr>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Posición</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Repuesto</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nº Paquete</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Orden</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Escaneado</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr *ngFor="let item of selectedPackageForView.items" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {{item.position}}
                  </td>
                  <td class="px-6 py-4">
                    <div class="font-medium text-gray-900">{{item.sparePartName}}</div>
                    <div class="text-sm text-blue-600" *ngIf="item.sparePartNameEs">🇪🇸 {{item.sparePartNameEs}}</div>
                    <div class="text-sm text-green-600" *ngIf="item.sparePartNamePt">🇧🇷 {{item.sparePartNamePt}}</div>
                    <div class="text-sm text-gray-500" *ngIf="item.remitoNumber">Remito: {{item.remitoNumber}}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.productCode}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.packageNumber}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.orderNumber}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{item.scannedAt | date:'short'}}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span class="px-2 py-1 text-xs font-medium rounded-full" [ngClass]="{
                            'bg-yellow-100 text-yellow-800': item.itemStatus === 'scanned',
                            'bg-blue-100 text-blue-800': item.itemStatus === 'to_load',
                            'bg-green-100 text-green-800': item.itemStatus === 'checked',
                            'bg-purple-100 text-purple-800': item.itemStatus === 'completed'
                          }">
                      {{item.itemStatus}}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <!-- Botón de eliminación individual removido - solo se permite desarmar paquete completo -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="!selectedPackageForView?.items || selectedPackageForView.items.length === 0"
            class="text-center py-8 text-gray-500">
            No hay repuestos en este paquete
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- VISTA HISTORIAL -->
  <div *ngIf="currentView === 'historial'" class="mt-24">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Historial de Acciones</h1>
      <button (click)="showMenu()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
        <i class="fas fa-arrow-left mr-2"></i>Volver al Menú
      </button>
    </div>

    <!-- Componente de Historial de Acciones -->
    <app-action-history></app-action-history>
  </div>

  <!-- VISTA EDICIÓN DE LISTA -->
  <div *ngIf="currentView === 'edit-list'" class="mt-24">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Editar Lista: {{currentEditingList?.name}}</h1>
      <div class="flex gap-2">
        <button (click)="showHistorial()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-arrow-left mr-2"></i>Volver al Historial
        </button>
        <button (click)="showMenu()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-home mr-2"></i>Menú Principal
        </button>
      </div>
    </div>

    <!-- Información de la Lista -->
    <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">Tipo</label>
          <span class="px-2 py-1 text-xs font-medium rounded-full" [ngClass]="{
                  'bg-blue-100 text-blue-800': currentEditingList?.type === 'empaquetado',
                  'bg-green-100 text-green-800': currentEditingList?.type === 'enviado',
                  'bg-purple-100 text-purple-800': currentEditingList?.type === 'cargado'
                }">
            {{currentEditingList?.type}}
          </span>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Estado</label>
          <span class="px-2 py-1 text-xs font-medium rounded-full" [ngClass]="{
                  'bg-yellow-100 text-yellow-800': currentEditingList?.status === 'active',
                  'bg-green-100 text-green-800': currentEditingList?.status === 'completed',
                  'bg-red-100 text-red-800': currentEditingList?.status === 'cancelled'
                }">
            {{currentEditingList?.status}}
          </span>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Total Items</label>
          <span class="text-lg font-semibold">{{scannedItems.length}}</span>
        </div>
      </div>
    </div>

    <!-- Acciones de Edición -->
    <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
      <h2 class="text-xl font-semibold mb-4">Acciones</h2>
      <div class="flex gap-4">
        <button (click)="showAddSparePartByCodeModal()"
          class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md"
          [disabled]="currentEditingList?.status !== 'active'">
          <i class="fas fa-plus mr-2"></i>Agregar Repuesto Existente
        </button>
        <div *ngIf="currentEditingList?.status === 'completed'"
          class="flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-md">
          <i class="fas fa-check-circle mr-2"></i>Lista Completada
        </div>
      </div>
    </div>

    <!-- Lista de Items -->
    <div class="bg-white p-6 rounded-lg shadow-lg">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Items en la Lista ({{scannedItems.length}})</h2>
      </div>

      <div *ngIf="scannedItems.length === 0" class="text-gray-500 text-center py-8">
        No hay items en la lista
      </div>

      <div *ngIf="scannedItems.length > 0" class="table-responsive-container table-scroll-horizontal">
        <table class="table-responsive table-mobile-cards table-fade-in">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Repuesto</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Paquete</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Orden</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let item of scannedItems; let i = index" [ngClass]="{
                  'bg-red-50 border-l-4 border-red-400': isReturnedItem(item),
                  'hover:bg-gray-50': !isReturnedItem(item)
                }">
              <td class="px-6 py-4 whitespace-nowrap" data-label="#">{{i + 1}}</td>
              <td class="px-6 py-4 whitespace-nowrap" data-label="Repuesto">
                <span [ngClass]="{'text-red-700 font-medium': isReturnedItem(item)}">
                  {{item.sparePartName}}
                  <span *ngIf="isReturnedItem(item)"
                    class="ml-2 px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full">
                    DEVUELTO
                  </span>
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap" data-label="Código">{{item.productCode}}</td>
              <td class="px-6 py-4 whitespace-nowrap" data-label="Paquete">{{item.packageNumber}}</td>
              <td class="px-6 py-4 whitespace-nowrap" data-label="Orden">{{item.orderNumber}}</td>
              <td class="px-6 py-4 whitespace-nowrap" data-label="Fecha">{{item.scannedAt | date:'short'}}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium" data-label="Acciones">
                <button (click)="markAsReturned(item)" [ngClass]="{
                          'text-orange-600 hover:text-orange-900': isReturnedItem(item),
                          'text-yellow-600 hover:text-yellow-900': !isReturnedItem(item)
                        }" class="mr-3">
                  <i [ngClass]="{
                       'fas fa-exchange-alt': isReturnedItem(item),
                       'fas fa-undo': !isReturnedItem(item)
                     }" class="mr-1"></i>
                  {{isReturnedItem(item) ? 'Cambiar Estado' : 'Marcar Devuelto'}}
                </button>
                <!-- Botón de eliminación individual removido - solo se permite desarmar paquete completo -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- MODALES -->
  <!-- Modal para Agregar Repuesto -->
  <div *ngIf="showAddByCodeModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">Agregar Repuesto</h2>
        <button (click)="closeAddSparePartModal()" class="text-gray-500 hover:text-gray-700">
          <i class="fas fa-times text-2xl"></i>
        </button>
      </div>

      <app-add-spare-part *ngIf="selectedOrderForEdit" [orderId]="selectedOrderForEdit"
        (close)="closeAddSparePartModal()">
      </app-add-spare-part>
    </div>
  </div>

  <!-- Modal para Historial de Repuestos -->
  <div *ngIf="showSparePartHistoryModal"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-full max-w-6xl max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">Historial de Repuestos</h2>
        <button (click)="closeSparePartHistoryModal()" class="text-gray-500 hover:text-gray-700">
          <i class="fas fa-times text-2xl"></i>
        </button>
      </div>

      <app-spare-part-history></app-spare-part-history>
    </div>
  </div>

  <!-- Modal para Agregar Repuesto por Código -->
  <div *ngIf="showAddByCodeModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-full max-w-md">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-bold">Agregar Repuesto Existente</h2>
        <button (click)="closeAddByCodeModal()" class="text-gray-500 hover:text-gray-700">
          <i class="fas fa-times text-xl"></i>
        </button>
      </div>

      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Código de Repuesto
        </label>
        <input type="text" [(ngModel)]="sparePartCodeToAdd" placeholder="Ingrese el código del repuesto"
          class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          (keyup.enter)="addSparePartByCode()">
      </div>

      <div *ngIf="foundSparePartToAdd" class="mb-4 p-3 bg-blue-50 rounded-md">
        <h4 class="font-medium text-blue-900">Repuesto Encontrado:</h4>
        <p class="text-sm text-blue-700">{{foundSparePartToAdd.sparePartName}}</p>
        <p class="text-sm text-blue-600">Código: {{foundSparePartToAdd.productCode}}</p>
      </div>

      <div class="flex justify-end gap-3">
        <button (click)="closeAddByCodeModal()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          Cancelar
        </button>
        <button (click)="addSparePartByCode()" [disabled]="!sparePartCodeToAdd.trim()"
          class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed">
          <i class="fas fa-plus mr-2"></i>Agregar
        </button>
      </div>
    </div>
  </div>

  <!-- MODALES ELEGANTES -->
  <!-- Modal de Alerta -->
  <div *ngIf="showAlertModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
      <div class="p-6">
        <div class="flex items-center mb-4">
          <div class="flex-shrink-0">
            <i *ngIf="modalType === 'success'" class="fas fa-check-circle text-green-500 text-3xl"></i>
            <i *ngIf="modalType === 'error'" class="fas fa-exclamation-circle text-red-500 text-3xl"></i>
            <i *ngIf="modalType === 'warning'" class="fas fa-exclamation-triangle text-yellow-500 text-3xl"></i>
            <i *ngIf="modalType === 'info'" class="fas fa-info-circle text-blue-500 text-3xl"></i>
          </div>
          <div class="ml-4">
            <h3 class="text-lg font-medium text-gray-900">{{modalTitle}}</h3>
            <p class="text-gray-600 mt-2 whitespace-pre-line">{{modalMessage}}</p>
          </div>
        </div>
        <div class="flex justify-end">
          <button (click)="closeAlertModal()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Confirmación -->
  <div *ngIf="showConfirmModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
      <div class="p-6">
        <div class="flex items-center mb-4">
          <div class="flex-shrink-0">
            <i class="fas fa-question-circle text-orange-500 text-3xl"></i>
          </div>
          <div class="ml-4">
            <h3 class="text-lg font-medium text-gray-900">{{modalTitle}}</h3>
            <p class="text-gray-600 mt-2">{{modalMessage}}</p>
          </div>
        </div>
        <div class="flex justify-end gap-3">
          <button (click)="closeConfirmModal()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
            Cancelar
          </button>
          <button (click)="confirmAction()" class="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Input -->
  <div *ngIf="showInputModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
      <div class="p-6">
        <div class="mb-4">
          <h3 class="text-lg font-medium text-gray-900 mb-4">{{modalTitle}}</h3>
          <input type="text" [(ngModel)]="inputValue" [placeholder]="inputPlaceholder"
            class="p-2 border rounded w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            (keyup.enter)="submitInput()" autofocus>
        </div>
        <div class="flex justify-end gap-3">
          <button (click)="closeInputModal()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
            Cancelar
          </button>
          <button (click)="submitInput()" [disabled]="!inputValue.trim()"
            class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Selección de Transporte -->
  <div *ngIf="showTransportSelectionModal"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
      <div class="p-6">
        <div class="mb-6">
          <h3 class="text-lg font-medium text-gray-900 mb-2">{{modalTitle}}</h3>
          <p class="text-gray-600">{{modalMessage}}</p>
        </div>

        <div class="space-y-4 mb-6">
          <!-- Opción Camión -->
          <button (click)="selectTransportType('camion')"
            class="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors text-left">
            <div class="flex items-center">
              <div class="flex-shrink-0">
                <i class="fas fa-truck text-2xl text-blue-500 mr-4"></i>
              </div>
              <div>
                <h4 class="font-semibold text-gray-900">Camión</h4>
                <p class="text-sm text-gray-600">Cargar repuestos empaquetados automáticamente</p>
              </div>
            </div>
          </button>

          <!-- Opción Camioneta -->
          <button (click)="selectTransportType('camioneta')"
            class="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-green-500 hover:bg-green-50 transition-colors text-left">
            <div class="flex items-center">
              <div class="flex-shrink-0">
                <i class="fas fa-car text-2xl text-green-500 mr-4"></i>
              </div>
              <div>
                <h4 class="font-semibold text-gray-900">Camioneta</h4>
                <p class="text-sm text-gray-600">Agregar repuestos manualmente</p>
              </div>
            </div>
          </button>
        </div>

        <div class="flex justify-end">
          <button (click)="closeTransportSelectionModal()"
            class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- VISTA / -->
  <div *ngIf="currentView === 'manage-existing'" class="mt-24">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Gestionar Paquetes Existentes</h1>
      <button (click)="showMenu()" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
        <i class="fas fa-arrow-left mr-2"></i>Volver al Menú
      </button>
    </div>

    <!-- Vista principal de paquetes existentes -->
    <div *ngIf="!selectedPackageForManagement">
      <!-- Filtros de búsqueda -->
      <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
        <h2 class="text-xl font-semibold mb-4">Filtros de Búsqueda</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Tipo</label>
            <select [(ngModel)]="searchFilters.type"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
              <option value="">Todos</option>
              <option value="empaquetado">Empaquetado</option>
              <option value="enviado">Enviado</option>
              <option value="cargado">Cargado</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Estado</label>
            <select [(ngModel)]="searchFilters.status"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
              <option value="">Todos</option>
              <option value="active">Activo</option>
              <option value="completed">Completado</option>
              <option value="cancelled">Cancelado</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
            <input type="text" [(ngModel)]="searchFilters.name" placeholder="Buscar por nombre..."
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Desde</label>
            <input type="date" [(ngModel)]="searchFilters.startDate"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Hasta</label>
            <input type="date" [(ngModel)]="searchFilters.endDate"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
          </div>
        </div>

        <div class="flex gap-4">
          <button (click)="applyFilters()" class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md">
            <i class="fas fa-search mr-2"></i>Buscar
          </button>
          <button (click)="clearFilters()" class="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-md">
            <i class="fas fa-times mr-2"></i>Limpiar
          </button>
        </div>
      </div>

      <!-- Lista de paquetes existentes -->
      <div class="bg-white p-6 rounded-lg shadow-lg">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-xl font-semibold">Paquetes Existentes ({{totalCount}})</h2>
          <div class="flex items-center space-x-4">
            <div class="text-sm text-gray-600">
              Página {{currentPage}} de {{totalPages}}
            </div>
          </div>
        </div>

        <div *ngIf="existingPackages.length === 0" class="text-gray-500 text-center py-8">
          No se encontraron paquetes con los filtros seleccionados
        </div>

        <div *ngIf="existingPackages.length > 0" class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nombre</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Tipo</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Items</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Creado</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let package of existingPackages" class="hover:bg-gray-50 cursor-pointer"
                (click)="selectPackageForManagement(package)">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="font-medium text-gray-900">{{package.name}}</div>
                  <div class="text-sm text-gray-500" *ngIf="package.createdBy">Por: {{package.createdBy}}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full" [ngClass]="{
                          'bg-blue-100 text-blue-800': package.type === 'empaquetado',
                          'bg-green-100 text-green-800': package.type === 'enviado',
                          'bg-purple-100 text-purple-800': package.type === 'cargado'
                        }">
                    {{package.type | titlecase}}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full" [ngClass]="{
                          'bg-green-100 text-green-800': package.status === 'active',
                          'bg-gray-100 text-gray-800': package.status === 'completed',
                          'bg-red-100 text-red-800': package.status === 'cancelled'
                        }">
                    {{package.status | titlecase}}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{package.totalItems}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{package.createdAt | date:'dd/MM/yyyy HH:mm'}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium" (click)="$event.stopPropagation()">
                  <div class="flex space-x-2">
                    <button (click)="selectPackageForManagement(package)"
                      class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs">
                      <i class="fas fa-edit mr-1"></i>Gestionar
                    </button>
                    <button (click)="deleteList(package)"
                      class="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs">
                      <i class="fas fa-trash mr-1"></i>Desarmar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div *ngIf="totalPages > 1" class="flex justify-center items-center mt-6 space-x-2">
          <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
            class="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-left"></i>
          </button>

          <span *ngFor="let page of [].constructor(totalPages); let i = index" class="px-3 py-1 rounded cursor-pointer"
            [ngClass]="{
                  'bg-blue-500 text-white': currentPage === i + 1,
                  'bg-gray-200 hover:bg-gray-300': currentPage !== i + 1
                }" (click)="goToPage(i + 1)">
            {{i + 1}}
          </span>

          <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
            class="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Vista detallada de un paquete seleccionado -->
    <div *ngIf="selectedPackageForManagement">
      <div class="flex justify-between items-center mb-6">
        <div>
          <h2 class="text-2xl font-bold">{{selectedPackageForManagement.name}}</h2>
          <div class="flex items-center space-x-4 mt-2">
            <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full" [ngClass]="{
                    'bg-blue-100 text-blue-800': selectedPackageForManagement.type === 'empaquetado',
                    'bg-green-100 text-green-800': selectedPackageForManagement.type === 'enviado',
                    'bg-purple-100 text-purple-800': selectedPackageForManagement.type === 'cargado'
                  }">
              {{selectedPackageForManagement.type | titlecase}}
            </span>
            <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full" [ngClass]="{
                    'bg-green-100 text-green-800': selectedPackageForManagement.status === 'active',
                    'bg-gray-100 text-gray-800': selectedPackageForManagement.status === 'completed',
                    'bg-red-100 text-red-800': selectedPackageForManagement.status === 'cancelled'
                  }">
              {{selectedPackageForManagement.status | titlecase}}
            </span>
            <span class="text-sm text-gray-600">
              {{selectedPackageForManagement.totalItems}} items
            </span>
          </div>
        </div>
        <button (click)="backToExistingPackages()"
          class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md">
          <i class="fas fa-arrow-left mr-2"></i>Volver
        </button>
      </div>

      <!-- Información del paquete -->
      <div class="bg-white p-6 rounded-lg shadow-lg mb-6">
        <h3 class="text-lg font-semibold mb-4">Información del Paquete</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Creado:</label>
            <p class="text-sm text-gray-900">{{selectedPackageForManagement.createdAt | date:'dd/MM/yyyy HH:mm'}}</p>
          </div>
          <div *ngIf="selectedPackageForManagement.completedAt">
            <label class="block text-sm font-medium text-gray-700">Completado:</label>
            <p class="text-sm text-gray-900">{{selectedPackageForManagement.completedAt | date:'dd/MM/yyyy HH:mm'}}</p>
          </div>
          <div *ngIf="selectedPackageForManagement.transportType">
            <label class="block text-sm font-medium text-gray-700">Tipo de Transporte:</label>
            <p class="text-sm text-gray-900">{{selectedPackageForManagement.transportType | titlecase}}</p>
          </div>
        </div>
      </div>

      <!-- Items del paquete -->
      <div class="bg-white p-6 rounded-lg shadow-lg">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold">Items del Paquete ({{selectedPackageForManagement.items.length}})</h3>
          <div class="flex space-x-2">
            <button (click)="printPackageLabels(selectedPackageForManagement)"
              class="bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-md">
              <i class="fas fa-print mr-2"></i>Imprimir Etiquetas
            </button>
          </div>
        </div>

        <div *ngIf="selectedPackageForManagement.items.length === 0" class="text-gray-500 text-center py-8">
          Este paquete no tiene items
        </div>

        <div *ngIf="selectedPackageForManagement.items.length > 0" class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Posición</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Repuesto</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nº Paquete</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Orden</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Escaneado</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                <!-- Header de Acciones eliminado - solo se permite desarmar paquete completo -->
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let item of selectedPackageForManagement.items; trackBy: trackByItemId"
                class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{item.position}}
                </td>
                <td class="px-6 py-4">
                  <div class="font-medium text-gray-900">{{item.sparePartName}}</div>
                  <div class="text-sm text-blue-600" *ngIf="item.sparePartNameEs">🇪🇸 {{item.sparePartNameEs}}</div>
                  <div class="text-sm text-green-600" *ngIf="item.sparePartNamePt">🇧🇷 {{item.sparePartNamePt}}</div>
                  <div class="text-sm text-gray-500" *ngIf="item.remitoNumber">Remito: {{item.remitoNumber}}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{item.productCode}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{item.packageNumber || 'N/A'}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{item.orderNumber || 'N/A'}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{item.scannedAt | date:'dd/MM/yyyy HH:mm'}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full" [ngClass]="{
                          'bg-blue-100 text-blue-800': item.itemStatus === 'scanned',
                          'bg-yellow-100 text-yellow-800': item.itemStatus === 'to_load',
                          'bg-green-100 text-green-800': item.itemStatus === 'checked',
                          'bg-gray-100 text-gray-800': item.itemStatus === 'completed'
                        }">
                    {{item.itemStatus | titlecase}}
                  </span>
                </td>
                <!-- Columna de acciones eliminada - solo se permite desarmar paquete completo -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Repuestos disponibles de la orden -->
      <div class="bg-white p-6 rounded-lg shadow-lg mt-6" *ngIf="availableSparePartsForOrder.length > 0">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold">Repuestos Disponibles de la Orden y Exportación</h3>
          <span class="text-sm text-gray-500">{{availableSparePartsForOrder.length}} disponibles</span>
        </div>

        <div class="mb-4 bg-blue-50 p-3 rounded-lg">
          <p class="text-sm text-blue-800">
            <i class="fas fa-info-circle mr-2"></i>
            <strong>Repuestos de la misma orden y exportación</strong> que pueden ser agregados a este paquete.
            Estos repuestos pertenecen a la orden {{selectedPackageForManagement.items[0]?.orderNumber}},
            comparten el mismo número de exportación del paquete
            y no están asignados a ningún otro paquete.
          </p>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Repuesto</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Código</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Exportación</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                <!-- Header de Acciones eliminado - solo se permite desarmar paquete completo -->
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let sparePart of availableSparePartsForOrder" class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="font-medium text-gray-900">{{sparePart.sparePartName}}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{sparePart.productCode}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                    Mismo que paquete
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    Disponible
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium"
                  *ngIf="selectedPackageForManagement.status === 'active'">
                  <button (click)="addAvailableSparePartToPackage(sparePart)"
                    class="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs">
                    <i class="fas fa-plus mr-1"></i>Agregar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Mensaje cuando no hay repuestos disponibles -->
      <div class="bg-gray-50 p-6 rounded-lg mt-6" *ngIf="availableSparePartsForOrder.length === 0">
        <div class="text-center">
          <i class="fas fa-check-circle text-green-500 text-3xl mb-2"></i>
          <h3 class="text-lg font-medium text-gray-900 mb-1">Todos los repuestos agregados</h3>
          <p class="text-gray-500">
            No hay repuestos adicionales disponibles de esta orden para agregar al paquete.
            Todos los repuestos de la orden {{selectedPackageForManagement.items[0]?.orderNumber}}
            con el mismo número de exportación del paquete ya están asignados a paquetes.
          </p>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- ============================================================================= -->
<!-- MODALES PARA GESTIÓN DE PAQUETES EXISTENTES -->
<!-- ============================================================================= -->

<!-- Modal para agregar repuesto a un paquete -->
<div *ngIf="showAddSparePartToPackageModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="closeAddSparePartToPackageModal()">
  <div class="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Agregar Repuesto al Paquete {{ currentPackageForAddSparePart }}</h3>
      <button (click)="closeAddSparePartToPackageModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-4 p-3 bg-blue-50 rounded-lg">
      <p class="text-sm text-blue-800">
        <i class="fas fa-info-circle mr-2"></i>
        Ingrese el ID del repuesto o código (ej: 2561, PC-367, CB-367) que desea agregar al paquete {{
        currentPackageForAddSparePart }}.
      </p>
    </div>

    <div class="space-y-4">
      <div>
        <label for="sparePartId" class="block text-sm font-medium text-gray-700 mb-2">
          ID del Repuesto o Código
        </label>
        <input type="text" id="sparePartId" #sparePartIdInput
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Ingrese el ID del repuesto o código (ej: 2561, PC-367)"
          (keyup.enter)="addSparePartToPackageByCode(currentPackageForAddSparePart!, sparePartIdInput.value)">
      </div>

      <div class="flex justify-end space-x-3">
        <button (click)="closeAddSparePartToPackageModal()"
          class="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors">
          Cancelar
        </button>
        <button (click)="addSparePartToPackageByCode(currentPackageForAddSparePart!, sparePartIdInput.value)"
          [disabled]="!sparePartIdInput.value || sparePartIdInput.value.trim() === ''"
          class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed">
          <i class="fas fa-plus mr-2"></i>Agregar Repuesto
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal para confirmar remover repuesto -->
<div *ngIf="showRemoveSparePartModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Confirmar Eliminación</h3>
      <button (click)="closeRemoveSparePartModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-6">
      <p class="text-gray-700 mb-4">
        ¿Estás seguro de que quieres remover el siguiente repuesto del paquete?
      </p>

      <div class="bg-gray-50 p-4 rounded-lg">
        <p class="font-medium">{{ selectedSparePartToRemove?.sparePartName }}</p>
        <p class="text-sm text-gray-600">Código: {{ selectedSparePartToRemove?.productCode }}</p>
        <p class="text-sm text-gray-600">Paquete: {{ selectedSparePartToRemove?.packageNumber }}</p>
      </div>
    </div>

    <div class="flex justify-end space-x-3">
      <button (click)="closeRemoveSparePartModal()"
        class="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-md">
        Cancelar
      </button>
      <button (click)="removeSparePartFromPackage()"
        class="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md">
        <i class="fas fa-trash mr-2"></i>Remover
      </button>
    </div>
  </div>
</div>

<!-- Modal para confirmar eliminar paquete vacío -->
<div *ngIf="showDeletePackageModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Confirmar Eliminación</h3>
      <button (click)="closeDeletePackageModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-6">
      <div class="flex items-center mb-4">
        <i class="fas fa-exclamation-triangle text-yellow-500 text-2xl mr-3"></i>
        <p class="text-gray-700 font-medium">Paquete Vacío</p>
      </div>

      <p class="text-gray-700 mb-4">
        El paquete <strong>{{ selectedPackageToDelete }}</strong> quedó vacío después de remover el repuesto.
      </p>

      <p class="text-gray-600 text-sm">
        ¿Deseas eliminar este paquete vacío? Esta acción no se puede deshacer.
      </p>
    </div>

    <div class="flex justify-end space-x-3">
      <button (click)="closeDeletePackageModal()"
        class="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-md">
        Cancelar
      </button>
      <button (click)="deleteEmptyPackage()" [disabled]="deletingEmptyPackage"
        class="bg-red-500 hover:bg-red-600 disabled:bg-gray-400 text-white px-4 py-2 rounded-md disabled:cursor-not-allowed">
        <span *ngIf="deletingEmptyPackage"
          class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></span>
        <i *ngIf="!deletingEmptyPackage" class="fas fa-trash mr-2"></i>
        {{ deletingEmptyPackage ? 'Eliminando...' : 'Eliminar Paquete' }}
      </button>
    </div>
  </div>
</div>

<!-- Modal de asignación de paquetes -->
<div *ngIf="showPackageAssignmentModalFlag"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="closePackageAssignmentModal()">
  <div class="bg-white rounded-lg p-6 w-full max-w-6xl max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Asignar Paquetes a Órdenes</h3>
      <button (click)="closePackageAssignmentModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>





    <!-- Vista de Paquetes por Estado -->
    <div>
      <div class="mb-6">
        <p class="text-gray-700 mb-4">
          Paquetes organizados por estado. Selecciona una orden para ver sus repuestos y asignaciones de paquetes.
        </p>

        <!-- Selector de tipo de paquete -->
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-2">Filtrar por tipo:</label>
          <select [(ngModel)]="selectedPackageType" (change)="filterPackagesByType()"
            class="w-full md:w-64 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
            <option value="">Todos los tipos</option>
            <option value="empaquetado">Empaquetado</option>
            <option value="cargado">Cargado al Camión</option>
            <option value="enviado">Enviado al Taller</option>
          </select>
        </div>
      </div>

      <!-- Paquetes en Empaquetado -->
      <div class="mb-8" *ngIf="!selectedPackageType || selectedPackageType === 'empaquetado'">
        <h4 class="text-lg font-semibold mb-4 text-green-700">
          <i class="fas fa-box mr-2"></i>Empaquetado ({{ filteredPackagesByStatus['empaquetado']?.length || 0 }})
        </h4>
        <div *ngIf="!filteredPackagesByStatus['empaquetado'] || filteredPackagesByStatus['empaquetado'].length === 0"
          class="text-gray-500 text-center py-4">
          No hay paquetes en estado de empaquetado
        </div>
        <div *ngIf="filteredPackagesByStatus['empaquetado'] && filteredPackagesByStatus['empaquetado'].length > 0"
          class="space-y-4">
          <div *ngFor="let package of filteredPackagesByStatus['empaquetado']"
            class="border border-green-200 rounded-lg bg-green-50 transition-colors">
            <!-- Header del paquete -->
            <div class="p-4 cursor-pointer hover:bg-green-100 transition-colors"
              (click)="togglePackageExpansion(package)">
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <h5 class="font-semibold text-green-800">{{ package.packageNumber }}</h5>
                  <p class="text-sm text-green-600">Orden: {{ package.orderNumber }}</p>
                  <p class="text-sm text-green-600">Items: {{ package.sparePartsCount || 0 }}</p>
                </div>
                <i class="fas transition-transform duration-200"
                  [ngClass]="isPackageExpanded(package) ? 'fa-chevron-down' : 'fa-chevron-right'"
                  [class.text-green-400]="true"></i>
              </div>
            </div>

            <!-- Contenido expandido del paquete -->
            <div *ngIf="isPackageExpanded(package)" class="border-t border-green-200 bg-white">
              <div class="p-4">
                <div class="flex justify-between items-center mb-3">
                  <h6 class="font-medium text-green-800">Repuestos del Paquete</h6>
                  <button (click)="selectOrderForAssignment(package); $event.stopPropagation()"
                    class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm">
                    <i class="fas fa-edit mr-1"></i>Asignar Repuestos
                  </button>
                </div>

                <!-- Lista de repuestos -->
                <div *ngIf="package.expandedItems && package.expandedItems.length > 0" class="space-y-2">
                  <div *ngFor="let item of package.expandedItems" class="p-3 bg-gray-50 rounded border">
                    <div class="flex justify-between items-start">
                      <div class="flex-1">
                        <p class="font-medium text-sm">{{ item.sparePartName }}</p>
                        <p class="text-xs text-gray-600">Código: {{ item.productCode }}</p>
                        <p class="text-xs text-gray-600">Orden: {{ item.orderNumber }}</p>
                        <p class="text-xs text-gray-600">Estado: {{ item.productStatus }}</p>
                      </div>
                      <div class="text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
                        {{ item.packageNumber }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mensaje si no hay repuestos -->
                <div *ngIf="!package.expandedItems || package.expandedItems.length === 0"
                  class="text-center py-4 text-gray-500">
                  <i class="fas fa-box-open text-2xl mb-2"></i>
                  <p>No hay repuestos en este paquete</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Paquetes en Cargado -->
      <div class="mb-8" *ngIf="!selectedPackageType || selectedPackageType === 'cargado'">
        <h4 class="text-lg font-semibold mb-4 text-blue-700">
          <i class="fas fa-truck mr-2"></i>Cargado al Camión ({{ filteredPackagesByStatus['cargado']?.length || 0 }})
        </h4>
        <div *ngIf="!filteredPackagesByStatus['cargado'] || filteredPackagesByStatus['cargado'].length === 0"
          class="text-gray-500 text-center py-4">
          No hay paquetes cargados al camión
        </div>
        <div *ngIf="filteredPackagesByStatus['cargado'] && filteredPackagesByStatus['cargado'].length > 0"
          class="space-y-4">
          <div *ngFor="let package of filteredPackagesByStatus['cargado']"
            class="border border-blue-200 rounded-lg bg-blue-50 transition-colors">
            <!-- Header del paquete -->
            <div class="p-4 cursor-pointer hover:bg-blue-100 transition-colors"
              (click)="togglePackageExpansion(package)">
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <h5 class="font-semibold text-blue-800">{{ package.packageNumber }}</h5>
                  <p class="text-sm text-blue-600">Orden: {{ package.orderNumber }}</p>
                  <p class="text-sm text-blue-600">Items: {{ package.sparePartsCount || 0 }}</p>
                </div>
                <i class="fas transition-transform duration-200"
                  [ngClass]="isPackageExpanded(package) ? 'fa-chevron-down' : 'fa-chevron-right'"
                  [class.text-blue-400]="true"></i>
              </div>
            </div>

            <!-- Contenido expandido del paquete -->
            <div *ngIf="isPackageExpanded(package)" class="border-t border-blue-200 bg-white">
              <div class="p-4">
                <div class="flex justify-between items-center mb-3">
                  <h6 class="font-medium text-blue-800">Repuestos del Paquete</h6>
                  <button (click)="selectOrderForAssignment(package); $event.stopPropagation()"
                    class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm">
                    <i class="fas fa-edit mr-1"></i>Asignar Repuestos
                  </button>
                </div>

                <!-- Lista de repuestos -->
                <div *ngIf="package.expandedItems && package.expandedItems.length > 0" class="space-y-2">
                  <div *ngFor="let item of package.expandedItems" class="p-3 bg-gray-50 rounded border">
                    <div class="flex justify-between items-start">
                      <div class="flex-1">
                        <p class="font-medium text-sm">{{ item.sparePartName }}</p>
                        <p class="text-xs text-gray-600">Código: {{ item.productCode }}</p>
                        <p class="text-xs text-gray-600">Orden: {{ item.orderNumber }}</p>
                        <p class="text-xs text-gray-600">Estado: {{ item.productStatus }}</p>
                      </div>
                      <div class="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                        {{ item.packageNumber }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mensaje si no hay repuestos -->
                <div *ngIf="!package.expandedItems || package.expandedItems.length === 0"
                  class="text-center py-4 text-gray-500">
                  <i class="fas fa-box-open text-2xl mb-2"></i>
                  <p>No hay repuestos en este paquete</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Paquetes en Enviado -->
      <div class="mb-8" *ngIf="!selectedPackageType || selectedPackageType === 'enviado'">
        <h4 class="text-lg font-semibold mb-4 text-purple-700">
          <i class="fas fa-shipping-fast mr-2"></i>Enviado al Taller ({{ filteredPackagesByStatus['enviado']?.length ||
          0 }})
        </h4>
        <div *ngIf="!filteredPackagesByStatus['enviado'] || filteredPackagesByStatus['enviado'].length === 0"
          class="text-gray-500 text-center py-4">
          No hay paquetes enviados al taller
        </div>
        <div *ngIf="filteredPackagesByStatus['enviado'] && filteredPackagesByStatus['enviado'].length > 0"
          class="space-y-4">
          <div *ngFor="let package of filteredPackagesByStatus['enviado']"
            class="border border-purple-200 rounded-lg bg-purple-50 transition-colors">
            <!-- Header del paquete -->
            <div class="p-4 cursor-pointer hover:bg-purple-100 transition-colors"
              (click)="togglePackageExpansion(package)">
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <h5 class="font-semibold text-purple-800">{{ package.packageNumber }}</h5>
                  <p class="text-sm text-purple-600">Orden: {{ package.orderNumber }}</p>
                  <p class="text-sm text-purple-600">Items: {{ package.sparePartsCount || 0 }}</p>
                </div>
                <i class="fas transition-transform duration-200"
                  [ngClass]="isPackageExpanded(package) ? 'fa-chevron-down' : 'fa-chevron-right'"
                  [class.text-purple-400]="true"></i>
              </div>
            </div>

            <!-- Contenido expandido del paquete -->
            <div *ngIf="isPackageExpanded(package)" class="border-t border-purple-200 bg-white">
              <div class="p-4">
                <div class="flex justify-between items-center mb-3">
                  <h6 class="font-medium text-purple-800">Repuestos del Paquete</h6>
                  <button (click)="selectOrderForAssignment(package); $event.stopPropagation()"
                    class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm">
                    <i class="fas fa-edit mr-1"></i>Asignar Repuestos
                  </button>
                </div>

                <!-- Lista de repuestos -->
                <div *ngIf="package.expandedItems && package.expandedItems.length > 0" class="space-y-2">
                  <div *ngFor="let item of package.expandedItems" class="p-3 bg-gray-50 rounded border">
                    <div class="flex justify-between items-start">
                      <div class="flex-1">
                        <p class="font-medium text-sm">{{ item.sparePartName }}</p>
                        <p class="text-xs text-gray-600">Código: {{ item.productCode }}</p>
                        <p class="text-xs text-gray-600">Orden: {{ item.orderNumber }}</p>
                        <p class="text-xs text-gray-600">Estado: {{ item.productStatus }}</p>
                      </div>
                      <div class="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded">
                        {{ item.packageNumber }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mensaje si no hay repuestos -->
                <div *ngIf="!package.expandedItems || package.expandedItems.length === 0"
                  class="text-center py-4 text-gray-500">
                  <i class="fas fa-box-open text-2xl mb-2"></i>
                  <p>No hay repuestos en este paquete</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-6">
      <button (click)="closePackageAssignmentModal()"
        class="bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-md">
        Cancelar
      </button>
    </div>
  </div>
</div>

<!-- MODAL DE SELECCIÓN DE VEHÍCULO -->
<div *ngIf="showVehicleSelectionModal" class="fixed inset-0 z-50 flex items-center justify-center">
  <!-- Fondo oscuro y borroso -->
  <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

  <!-- Modal -->
  <div class="relative bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4 z-10">
    <div class="text-center">
      <h2 class="text-2xl font-bold text-gray-900 mb-6">Seleccionar Tipo de Vehículo</h2>
      <p class="text-gray-600 mb-8">¿Qué tipo de vehículo utilizarás para la carga?</p>

      <div class="space-y-4">
        <!-- Botón Camión -->
        <button (click)="selectVehicleType('camion')"
          class="w-full bg-purple-500 hover:bg-purple-600 text-white p-4 rounded-lg transition-colors flex items-center justify-center space-x-3">
          <i class="fas fa-truck text-2xl"></i>
          <span class="text-lg font-semibold">Camión</span>
        </button>

        <!-- Botón Camioneta -->
        <button (click)="selectVehicleType('camioneta')"
          class="w-full bg-blue-500 hover:bg-blue-600 text-white p-4 rounded-lg transition-colors flex items-center justify-center space-x-3">
          <i class="fas fa-truck-pickup text-2xl"></i>
          <span class="text-lg font-semibold">Camioneta</span>
        </button>
      </div>

      <!-- Botón Cancelar -->
      <button (click)="showVehicleSelectionModal = false"
        class="mt-6 text-gray-500 hover:text-gray-700 transition-colors">
        Cancelar
      </button>
    </div>
  </div>
</div>

<!-- MODAL PRINCIPAL DE CARGA AL CAMIÓN -->
<div *ngIf="showMainLoadingModal" class="loading-modal fixed inset-0 z-50 flex items-end lg:items-center justify-center"
  (click)="closeMainLoadingModal()">
  <!-- Fondo oscuro y borroso -->
  <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>

  <!-- Modal principal -->
  <div class="loading-modal-shell relative bg-white shadow-xl max-w-7xl w-full z-10 flex flex-col
              max-lg:h-[100dvh] max-lg:max-h-[100dvh] max-lg:rounded-none max-lg:mx-0
              lg:max-h-[90vh] lg:rounded-lg lg:mx-4"
    (click)="$event.stopPropagation()">
    <!-- Header del modal -->
    <div class="loading-modal-header flex justify-between items-center p-4 lg:p-6 pb-3 lg:pb-4 border-b flex-shrink-0">
      <h2 class="text-xl lg:text-2xl font-bold text-gray-900">
        Carga al {{ transportType === 'camion' ? 'Camión' : 'Camioneta' }}
      </h2>
      <button (click)="closeMainLoadingModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <i class="fas fa-times text-xl lg:text-2xl"></i>
      </button>
    </div>

    <!-- Contenido del modal -->
    <div class="loading-modal-body flex-1 min-h-0 overflow-hidden flex flex-col px-4 lg:px-6 py-3">
      <!-- Indicador del tipo de vehículo seleccionado -->
      <div class="loading-modal-vehicle-banner mb-3 p-2 lg:p-3 rounded-lg flex-shrink-0" [ngClass]="{
        'bg-blue-50 border border-blue-200': transportType === 'camioneta',
        'bg-purple-50 border border-purple-200': transportType === 'camion'
      }">
        <div class="flex items-center">
          <i class="fas mr-2 text-lg" [ngClass]="{
            'fa-truck-pickup text-blue-600': transportType === 'camioneta',
            'fa-truck text-purple-600': transportType === 'camion'
          }"></i>
          <div>
            <h4 class="font-semibold text-gray-800 text-sm lg:text-base">
              Cargando a {{ transportType === 'camion' ? 'Camión' : 'Camioneta' }}
            </h4>
            <p class="text-xs lg:text-sm text-gray-600 hidden sm:block">
              Los repuestos seleccionados serán marcados como transportados por {{ transportType === 'camion' ? 'camión'
              : 'camioneta' }}
            </p>
          </div>
        </div>
      </div>

      <!-- Tabs móvil -->
      <div class="loading-modal-tabs lg:hidden flex border border-gray-200 rounded-lg overflow-hidden mb-3 flex-shrink-0">
        <button type="button" (click)="loadingModalMobileTab = 'pending'"
          class="loading-modal-tab flex-1 py-2.5 text-sm font-medium transition-colors"
          [ngClass]="loadingModalMobileTab === 'pending'
            ? 'bg-blue-500 text-white'
            : 'bg-white text-gray-600 hover:bg-gray-50'">
          Pendientes ({{ empaquetadosForLoading.length }})
        </button>
        <button type="button" (click)="loadingModalMobileTab = 'scanned'"
          class="loading-modal-tab flex-1 py-2.5 text-sm font-medium transition-colors border-l border-gray-200"
          [ngClass]="loadingModalMobileTab === 'scanned'
            ? 'bg-green-500 text-white'
            : 'bg-white text-gray-600 hover:bg-gray-50'">
          Cargados ({{ scannedItemsForLoading.length }})
        </button>
      </div>

      <div class="loading-modal-grid grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 flex-1 min-h-0 lg:overflow-hidden">
        <!-- PANEL IZQUIERDO: Repuestos Disponibles para Carga -->
        <div class="loading-modal-panel bg-gray-50 rounded-lg p-3 lg:p-4 flex flex-col min-h-0 overflow-hidden lg:flex"
          [class.max-lg:hidden]="loadingModalMobileTab !== 'pending'">
          <h3 class="text-base lg:text-lg font-semibold text-gray-800 mb-3 lg:mb-4 flex items-center flex-shrink-0">
            <i class="fas fa-boxes text-blue-500 mr-2"></i>
            Repuestos Disponibles para Carga
            <span class="ml-2 text-sm font-normal text-gray-500">({{ empaquetadosForLoading.length }})</span>
          </h3>

          <!-- Loading spinner -->
          <div *ngIf="loadingEmpaquetados" class="flex justify-center items-center py-8 flex-1">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <span class="ml-2 text-gray-600">Cargando repuestos...</span>
          </div>

          <!-- Lista de repuestos disponibles -->
          <div *ngIf="!loadingEmpaquetados && empaquetadosForLoading.length > 0"
            class="loading-modal-panel-list space-y-3 flex-1 overflow-y-auto min-h-0">
            <div *ngFor="let item of empaquetadosForLoading"
              class="bg-white p-3 rounded border hover:shadow-md transition-shadow">
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <p class="font-medium text-sm text-gray-800">{{ item.sparePartName || 'Sin nombre' }}</p>
                  <p class="text-xs text-gray-600">Código: {{ item.productCode }}</p>
                  <p class="text-xs text-gray-600">Paquete: {{ item.packageNumber }}</p>
                  <p class="text-xs text-gray-600">Orden: {{ item.orderNumber }}</p>
                  <p class="text-xs text-gray-600">Estado: {{ item.productStatus }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensaje si no hay repuestos -->
          <div *ngIf="!loadingEmpaquetados && empaquetadosForLoading.length === 0"
            class="text-center py-8 text-gray-500 flex-1 flex flex-col justify-center">
            <i class="fas fa-box-open text-3xl mb-2"></i>
            <p>No hay repuestos disponibles para carga</p>
          </div>
        </div>

        <!-- PANEL DERECHO: Repuestos Cargados -->
        <div class="loading-modal-panel bg-gray-50 rounded-lg p-3 lg:p-4 flex flex-col min-h-0 overflow-hidden lg:flex"
          [class.max-lg:hidden]="loadingModalMobileTab !== 'scanned'">
          <h3 class="text-base lg:text-lg font-semibold text-gray-800 mb-3 lg:mb-4 flex items-center flex-shrink-0">
            <i class="fas fa-check-circle text-green-500 mr-2"></i>
            Repuestos Cargados
            <span class="ml-2 text-sm font-normal text-gray-500">({{ scannedItemsForLoading.length }})</span>
          </h3>

          <!-- Input para escanear -->
          <div class="mb-3 lg:mb-4 flex-shrink-0">
            <label class="block text-sm font-medium text-gray-700 mb-2">Escanear Paquete u Orden</label>
            <details class="lg:hidden mb-2 text-xs text-gray-500">
              <summary class="cursor-pointer text-blue-600">Ver instrucciones</summary>
              <p class="mt-2">
                <strong>Paquete:</strong> E123-PAC0001 — carga todos sus repuestos.<br>
                <strong>Orden:</strong> ORD-001 — carga todos los paquetes de esa orden.
              </p>
            </details>
            <p class="hidden lg:block text-xs text-gray-500 mb-2">
              • <strong>Paquete:</strong> Escribe un número de paquete (ej: E123-PAC0001) para cargar todos sus
              repuestos<br>
              • <strong>Orden:</strong> Escribe un número de orden (ej: ORD-001) para cargar todos los paquetes de esa
              orden
            </p>
            <div class="loading-modal-scan-row flex">
              <input #scanningInput type="text" [(ngModel)]="currentScanningCode"
                (ngModelChange)="onCurrentScanningCodeChange()"
                placeholder="Escanea paquete u orden..."
                class="flex-1 min-w-0 rounded-l-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-2"
                (keyup.enter)="scanIndividualSparePart()" [disabled]="isScanningIndividual" autofocus>
              <button (click)="scanIndividualSparePart()"
                [disabled]="!currentScanningCode?.trim() || isScanningIndividual"
                class="bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 text-white px-3 lg:px-4 py-2 rounded-r-md transition-colors whitespace-nowrap">
                <span *ngIf="isScanningIndividual"
                  class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></span>
                <i *ngIf="!isScanningIndividual" class="fas fa-search mr-1 lg:mr-2"></i>
                {{ isScanningIndividual ? '...' : 'Procesar' }}
              </button>
            </div>
            <!-- Aviso visible cuando el paquete/orden no tiene repuestos asociados -->
            <div *ngIf="loadingModalScanError" class="mt-3 p-3 rounded-lg bg-amber-50 border border-amber-200 flex items-start">
              <i class="fas fa-exclamation-triangle text-amber-600 mt-0.5 mr-2 flex-shrink-0"></i>
              <p class="text-sm text-amber-800">{{ loadingModalScanError }}</p>
            </div>
          </div>

          <!-- Indicador de procesamiento -->
          <div *ngIf="isScanningIndividual" class="text-center py-3 mb-2 flex-shrink-0">
            <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto"></div>
            <p class="text-sm text-gray-600 mt-2">Procesando escaneo...</p>
          </div>

          <!-- Lista de repuestos escaneados -->
          <div *ngIf="scannedItemsForLoading.length > 0" class="loading-modal-panel-list space-y-3 flex-1 overflow-y-auto min-h-0">
            <div *ngFor="let item of scannedItemsForLoading; let i = index; trackBy: trackByItemId"
              class="bg-white p-3 rounded border border-green-200 bg-green-50 relative">
              <!-- Botón para quitar el item -->
              <button (click)="removeItemFromScanned(item, i); $event.stopPropagation()"
                class="absolute top-2 right-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full p-1 transition-colors"
                title="Quitar de la lista">
                <i class="fas fa-times"></i>
              </button>
              <div class="flex justify-between items-start pr-8">
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-sm text-gray-800">{{ item.sparePartName || 'Sin nombre' }}</p>
                  <div class="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-gray-600 mb-1">
                    <span class="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium">
                      Orden #{{ item.orderItemNumber }}
                    </span>
                    <span>Orden: {{ item.orderNumber }}</span>
                  </div>
                  <p class="text-xs text-gray-600">Código: {{ item.productCode }}</p>
                  <p class="text-xs text-gray-600">Paquete: {{ item.packageNumber }}</p>
                  <p class="text-xs text-gray-600">Estado: {{ item.productStatus }}</p>
                </div>
                <div class="ml-2 flex-shrink-0 hidden sm:block">
                  <span
                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    <i class="fas fa-truck mr-1"></i>
                    Listo
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensaje si no hay repuestos escaneados -->
          <div *ngIf="scannedItemsForLoading.length === 0"
            class="text-center py-8 text-gray-500 flex-1 flex flex-col justify-center">
            <i class="fas fa-truck text-3xl mb-2"></i>
            <p>No hay repuestos cargados aún</p>
            <p class="text-sm">Escanea paquetes u órdenes para comenzar</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer del modal -->
    <div class="loading-modal-footer flex justify-between items-center p-4 lg:p-6 pt-3 lg:pt-4 border-t flex-shrink-0">
      <div class="text-sm text-gray-600">
        <span class="font-medium">{{ scannedItemsForLoading.length }}</span> de
        <span class="font-medium">{{ scannedItemsForLoading.length + empaquetadosForLoading.length }}</span> repuestos
        cargados
      </div>

      <div class="loading-modal-footer-actions space-x-2 lg:space-x-3">
        <button (click)="volverAVistaPrevia()"
          class="bg-gray-300 hover:bg-gray-400 text-gray-700 px-3 lg:px-4 py-2 rounded-md transition-colors">
          Cancelar
        </button>
        <button (click)="finalizeTruckLoading()" [disabled]="scannedItemsForLoading.length === 0"
          class="bg-green-500 hover:bg-green-600 disabled:bg-gray-400 text-white px-3 lg:px-4 py-2 rounded-md transition-colors">
          <i class="fas fa-truck mr-2"></i>
          Exportar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL DE CONFIRMACIÓN DE CARGA COMPLETADA -->
<div *ngIf="showExportConfirmationModal"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="closeExportConfirmationModal()">
  <div class="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center p-6 border-b bg-green-50">
      <div>
        <h3 class="text-xl font-bold text-green-800">✅ Carga Completada Exitosamente</h3>
        <p class="text-sm text-green-600 mt-1">Los siguientes repuestos han sido exportados</p>
      </div>
      <button (click)="closeExportConfirmationModal()" class="text-gray-500 hover:text-gray-700 p-2">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <div class="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
      <!-- Resumen -->
      <div class="bg-blue-50 p-4 rounded-lg mb-6">
        <div class="grid grid-cols-3 gap-4 text-center">
          <div>
            <p class="text-2xl font-bold text-green-600">{{ exportedItemsList.length }}</p>
            <p class="text-sm text-gray-600">Repuestos Exportados</p>
          </div>
          <div>
            <p class="text-2xl font-bold text-blue-600">EXPORTADO</p>
            <p class="text-sm text-gray-600">Nuevo Estado</p>
          </div>
          <div>
            <p class="text-2xl font-bold text-purple-600">{{ transportType === 'camion' ? 'Camión' : 'Camioneta' }}</p>
            <p class="text-sm text-gray-600">Tipo de Vehículo</p>
          </div>
        </div>
      </div>

      <!-- Lista de repuestos exportados -->
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Repuesto</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Paquete</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orden</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let item of exportedItemsList; let i = index" class="hover:bg-green-50 transition-colors">
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ i + 1 }}</td>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex items-center">
                  <div class="flex-shrink-0 h-8 w-8">
                    <span class="inline-flex items-center justify-center h-8 w-8 rounded-full bg-green-100">
                      <i class="fas fa-check text-green-600 text-sm"></i>
                    </span>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm font-medium text-gray-900">{{ item.sparePartName || 'Sin nombre' }}</p>
                  </div>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ item.productCode }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ item.packageNumber }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ item.orderNumber }}</td>
              <td class="px-6 py-4 whitespace-nowrap">
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <i class="fas fa-truck mr-1"></i>
                  EXPORTADO
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="flex justify-end items-center p-6 border-t bg-gray-50">
      <button (click)="closeExportConfirmationModal()"
        class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md transition-colors">
        <i class="fas fa-check mr-2"></i>
        Entendido
      </button>
    </div>
  </div>
</div>

<!-- MODAL DE DETALLES DEL PAQUETE EN HISTORIAL -->
<div *ngIf="showPackageHistoryModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="closePackageHistoryModal()">
  <div class="bg-white rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center p-6 border-b">
      <div>
        <h3 class="text-xl font-bold">{{ selectedPackageForHistory?.packageNumber }}</h3>
        <p class="text-sm text-gray-600">{{ selectedPackageForHistory?.packageName }}</p>
        <p class="text-sm text-gray-600">
          Fecha: {{ selectedPackageForHistory?.fecha ? (selectedPackageForHistory.fecha | date:'dd/MM/yyyy HH:mm') : 'Sin fecha' }} |
          Vehículo: {{ selectedPackageForHistory?.tipoVehiculo === 'camion' ? 'Camión' : 'Camioneta' }}
        </p>
      </div>
      <div class="flex items-center space-x-3">
        <button (click)="closePackageHistoryModal()" class="text-gray-500 hover:text-gray-700 p-2">
          <i class="fas fa-times text-xl"></i>
        </button>
      </div>
    </div>

    <div class="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
      <!-- Resumen del paquete -->
      <div class="bg-blue-50 p-4 rounded-lg mb-6">
        <div class="grid grid-cols-3 gap-4 text-center">
          <div>
            <p class="text-2xl font-bold text-green-600">{{ selectedPackageForHistory?.repuestosCargados }}</p>
            <p class="text-sm text-gray-600">Repuestos Cargados</p>
          </div>
          <div>
            <p class="text-2xl font-bold text-orange-600">{{ selectedPackageForHistory?.repuestosNoCargados }}</p>
            <p class="text-sm text-gray-600">No Cargados</p>
          </div>
          <div>
            <p class="text-2xl font-bold text-blue-600">{{ selectedPackageForHistory?.totalRepuestos }}</p>
            <p class="text-sm text-gray-600">Total Repuestos</p>
          </div>
        </div>
      </div>

      <!-- Lista de repuestos -->
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Repuesto</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Precio Unit.
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Orden</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr
              *ngFor="let repuesto of selectedPackageForHistory?.repuestos; let i = index; trackBy: trackBySparePartId"
              class="hover:bg-gray-50">
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ repuesto.sparePartName }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ repuesto.productCode }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ repuesto.amount }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                ${{ repuesto.unitPrice | number:'1.2-2' }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ repuesto.orderNumber }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" [ngClass]="{
                        'bg-green-100 text-green-800': repuesto.productStatus === 'CARGADO',
                        'bg-orange-100 text-orange-800': repuesto.productStatus === 'EXPORTADO-NO-CARGADO'
                      }">
                  <i class="fas fa-circle mr-1" [ngClass]="{
                       'text-green-500': repuesto.productStatus === 'CARGADO',
                       'text-orange-500': repuesto.productStatus === 'EXPORTADO-NO-CARGADO'
                     }"></i>
                  {{ repuesto.productStatus }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL DE CONFIRMACIÓN DE EMPAQUETADO -->
<div *ngIf="showPackagingConfirmationModal"
  class="packaging-modal fixed inset-0 z-50 flex items-end lg:items-center justify-center">
  <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" (click)="cancelPackagePackaging()"></div>

  <div class="packaging-modal-shell relative bg-white shadow-xl max-w-4xl w-full flex flex-col
              max-lg:h-[100dvh] max-lg:max-h-[100dvh] max-lg:rounded-none
              lg:max-h-[90vh] lg:rounded-lg lg:mx-4"
    (click)="$event.stopPropagation()">

    <!-- Header del modal -->
    <div class="packaging-modal-header bg-gradient-to-r from-blue-600 to-blue-700 px-4 lg:px-6 py-2 lg:py-4 text-white flex-shrink-0">
      <div class="flex justify-between items-center gap-3">
        <div class="min-w-0">
          <h3 class="text-lg lg:text-xl font-bold truncate">
            <i class="fas fa-box-check mr-2"></i>
            Confirmar Empaquetado
          </h3>
          <p class="text-blue-100 text-xs lg:text-sm mt-1 hidden sm:block">
            Revisa los repuestos antes de confirmar
          </p>
        </div>
        <button (click)="cancelPackagePackaging()"
          class="text-blue-200 hover:text-white p-2 rounded-full hover:bg-blue-500 transition-colors flex-shrink-0">
          <i class="fas fa-times text-xl"></i>
        </button>
      </div>
    </div>

    <!-- Contenido del modal -->
    <div class="packaging-modal-body flex-1 min-h-0 overflow-hidden flex flex-col px-3 lg:px-6 py-2 lg:py-3">
      <div *ngIf="pendingPackageMessage" class="mb-2 flex-shrink-0">
        <div
          class="rounded-lg border px-3 py-2 text-sm"
          [ngClass]="pendingPackageMessageType === 'error'
            ? 'bg-red-50 border-red-200 text-red-700'
            : 'bg-green-50 border-green-200 text-green-700'">
          <i
            [class]="pendingPackageMessageType === 'error' ? 'fas fa-exclamation-circle mr-2' : 'fas fa-check-circle mr-2'"></i>
          {{ pendingPackageMessage }}
        </div>
      </div>

      <!-- Información del paquete -->
      <div *ngIf="packageToConfirmInfo"
        class="packaging-modal-package-info bg-blue-50 border border-blue-200 rounded-lg p-2 lg:p-4 mb-2 flex-shrink-0">
        <div class="flex items-center justify-between gap-3">
          <div class="min-w-0">
            <h4 class="font-semibold text-blue-800 text-base lg:text-lg truncate">
              <i class="fas fa-package mr-1"></i>
              {{ packageToConfirmInfo.packageNumber }}
            </h4>
            <p class="text-blue-600 text-xs lg:text-sm mt-1">
              Orden: {{ packageToConfirmInfo.orderNumber }}
              · {{ packageToConfirmInfo.sparePartsCount }} repuestos
            </p>
          </div>
          <div class="text-right flex-shrink-0">
            <div class="text-xl lg:text-2xl font-bold text-blue-700">
              {{ packageSparePartsToConfirm.length }}
            </div>
            <div class="text-xs text-blue-600">listos</div>
          </div>
        </div>
      </div>

      <!-- Empaquetador -->
      <div class="bg-white border border-gray-200 rounded-lg p-2 lg:p-4 mb-2 flex-shrink-0">
        <label for="packaging-user-selector" class="block text-xs lg:text-sm font-medium text-gray-700 mb-1">
          Empaquetador <span class="text-red-600">*</span>
        </label>
        <select
          id="packaging-user-selector"
          [(ngModel)]="selectedPackager"
          class="w-full rounded-lg border border-gray-300 px-3 py-1.5 lg:py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
        >
          <option [ngValue]="null">Selecciona un empaquetador</option>
          <option *ngFor="let packager of availablePackagers" [ngValue]="packager">
            {{ packager }}
          </option>
        </select>
      </div>

      <!-- Loading state -->
      <div *ngIf="loadingPackageDetails" class="text-center py-12 flex-1 flex flex-col justify-center">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto"></div>
        <p class="mt-4 text-gray-600 text-sm">Cargando detalles del paquete...</p>
      </div>

      <!-- Lista de repuestos -->
      <div *ngIf="!loadingPackageDetails && packageSparePartsToConfirm.length > 0"
        class="packaging-modal-parts-section flex flex-col flex-1 min-h-0 overflow-hidden">
        <h5 class="font-semibold text-gray-800 mb-1.5 flex items-center flex-shrink-0 text-sm lg:text-base">
          <i class="fas fa-list-ul mr-2 text-gray-600"></i>
          Repuestos a Empaquetar ({{ packageSparePartsToConfirm.length }})
        </h5>

        <div class="packaging-modal-parts-list flex-1 min-h-0 overflow-y-auto bg-gray-50 rounded-lg p-2 lg:p-4 border border-gray-200">
          <div class="grid gap-2 lg:gap-3">
            <div *ngFor="let sparePart of packageSparePartsToConfirm; trackBy: trackBySparePartId"
              class="p-3 lg:p-4 rounded-lg border"
              [ngClass]="isSparePartPackagingBlocked(sparePart)
                ? 'bg-yellow-50 border-yellow-300'
                : 'bg-white border-gray-200'">

              <div class="flex justify-between items-start gap-2">
                <div class="flex-1 min-w-0">
                  <div class="flex items-start gap-2">
                    <div class="w-7 h-7 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i class="fas fa-cog text-blue-600 text-xs"></i>
                    </div>
                    <div class="min-w-0">
                      <h6 class="font-medium text-gray-900 text-sm">
                        {{ sparePart.sparePartName || 'Sin nombre' }}
                      </h6>
                      <p class="text-xs text-gray-600 truncate" *ngIf="sparePart.sparePartNameEs">
                        🇪🇸 {{ sparePart.sparePartNameEs }}
                      </p>
                      <p class="text-xs text-gray-600 truncate" *ngIf="sparePart.sparePartNamePt">
                        🇧🇷 {{ sparePart.sparePartNamePt }}
                      </p>
                    </div>
                  </div>

                  <div class="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 text-xs lg:text-sm">
                    <div>
                      <span class="font-medium text-gray-700">Código:</span>
                      <span class="text-gray-600 ml-1">{{ sparePart.productCode }}</span>
                    </div>
                    <div>
                      <span class="font-medium text-gray-700">Orden:</span>
                      <span class="text-gray-600 ml-1">{{ sparePart.orderNumber }}</span>
                    </div>
                    <div>
                      <span class="font-medium text-gray-700">Estado:</span>
                      <span class="text-gray-600 ml-1">{{ sparePart.productStatus || 'N/A' }}</span>
                    </div>
                    <div>
                      <span class="font-medium text-gray-700">Cant.:</span>
                      <span class="text-gray-600 ml-1">{{ sparePart.amount || 1 }}</span>
                    </div>
                    <div *ngIf="isSparePartNeedReviewBlocked(sparePart)" class="col-span-2">
                      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                        <i class="fas fa-exclamation-triangle mr-1"></i>
                        Requiere revisión
                      </span>
                    </div>
                    <div *ngIf="isSparePartIsDamagedBlocked(sparePart)" class="col-span-2">
                      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                        <i class="fas fa-exclamation-triangle mr-1"></i>
                        Daño no aprobado ({{ sparePart.isDamaged }})
                      </span>
                    </div>
                  </div>
                </div>

                <div class="flex-shrink-0">
                  <div *ngIf="!isSparePartPackagingBlocked(sparePart)"
                    class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
                    <i class="fas fa-check text-green-600 text-xs"></i>
                  </div>
                  <div *ngIf="isSparePartPackagingBlocked(sparePart)"
                    class="w-5 h-5 bg-yellow-100 rounded-full flex items-center justify-center">
                    <i class="fas fa-exclamation-triangle text-yellow-600 text-xs"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Resumen al final del scroll de repuestos -->
          <div *ngIf="!hasPackagingConfirmationBlock()"
            class="bg-green-50 border border-green-200 rounded-lg p-2 mt-3">
            <div class="flex items-center justify-between text-sm">
              <span class="font-medium text-green-800">
                <i class="fas fa-check-circle text-green-600 mr-1"></i>
                Listo para empaquetar
              </span>
              <span class="text-green-700 text-xs lg:text-sm">
                {{ packageSparePartsToConfirm.length }} verificado(s)
              </span>
            </div>
          </div>
          <div *ngIf="hasPackagingConfirmationBlock()"
            class="bg-yellow-50 border border-yellow-200 rounded-lg p-2 mt-3">
            <div class="text-sm text-yellow-800">
              <i class="fas fa-exclamation-triangle text-yellow-600 mr-1"></i>
              Hay repuestos bloqueados (revisión o daño no aprobado). Resuélvelo en historial antes de confirmar.
            </div>
          </div>
        </div>
      </div>

      <!-- Mensaje si no hay repuestos -->
      <div *ngIf="!loadingPackageDetails && packageSparePartsToConfirm.length === 0"
        class="text-center py-12 flex-1 flex flex-col justify-center">
        <i class="fas fa-exclamation-triangle text-yellow-500 text-4xl mb-4"></i>
        <h5 class="text-lg font-medium text-gray-900 mb-2">No se encontraron repuestos</h5>
        <p class="text-gray-600 text-sm px-4">Este paquete no contiene repuestos o ha ocurrido un error al cargarlos.</p>
      </div>
    </div>

    <!-- Configuración de Impresión — colapsable en móvil -->
    <details class="packaging-modal-print lg:hidden flex-shrink-0 bg-blue-50 px-4 py-2 border-t border-blue-200">
      <summary class="cursor-pointer text-sm font-medium text-blue-800 py-1">
        <i class="fas fa-print mr-2"></i>Configuración de impresión
      </summary>
      <div class="pt-3 pb-1 space-y-3">
        <div class="packaging-modal-print-options flex flex-wrap gap-3">
          <label class="flex items-center text-sm">
            <input type="radio" [(ngModel)]="printerType" value="paper"
              class="mr-2 text-blue-600 focus:ring-blue-500">
            Papel A4
          </label>
          <label class="flex items-center text-sm">
            <input type="radio" [(ngModel)]="printerType" value="thermal"
              class="mr-2 text-blue-600 focus:ring-blue-500">
            Ticketera
          </label>
        </div>
        <div *ngIf="printerType === 'thermal'" class="flex items-center gap-2">
          <span class="text-sm text-gray-600">Ancho:</span>
          <select [(ngModel)]="thermalPrinterWidth"
            class="text-sm border border-gray-300 rounded px-2 py-1 flex-1">
            <option value="58mm">58mm</option>
            <option value="80mm">80mm</option>
            <option value="100mm">100mm</option>
          </select>
        </div>
        <p class="text-xs text-blue-600">
          <i class="fas fa-info-circle mr-1"></i>{{ getPrinterInfoText() }}
        </p>
      </div>
    </details>

    <!-- Configuración de Impresión — desktop -->
    <div class="packaging-modal-print-desktop hidden lg:block flex-shrink-0 bg-blue-50 px-6 py-4 border-t border-blue-200">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div class="packaging-modal-print-row flex flex-wrap items-center gap-4">
          <div class="flex items-center">
            <i class="fas fa-print text-blue-600 mr-2"></i>
            <span class="font-medium text-blue-800">Configuración de Impresión:</span>
          </div>
          <div class="flex items-center gap-3">
            <label class="flex items-center">
              <input type="radio" [(ngModel)]="printerType" value="paper"
                class="mr-2 text-blue-600 focus:ring-blue-500">
              <span class="text-sm text-gray-700">Papel A4</span>
            </label>
            <label class="flex items-center">
              <input type="radio" [(ngModel)]="printerType" value="thermal"
                class="mr-2 text-blue-600 focus:ring-blue-500">
              <span class="text-sm text-gray-700">Ticketera Térmica</span>
            </label>
          </div>
          <div *ngIf="printerType === 'thermal'" class="flex items-center gap-2">
            <span class="text-sm text-gray-600">Ancho:</span>
            <select [(ngModel)]="thermalPrinterWidth"
              class="text-sm border border-gray-300 rounded px-2 py-1 focus:ring-blue-500 focus:border-blue-500">
              <option value="58mm">58mm x 100mm</option>
              <option value="80mm">80mm x 100mm</option>
              <option value="100mm">100mm x 150mm</option>
            </select>
          </div>
        </div>
        <div class="text-xs text-blue-600">
          <i class="fas fa-info-circle mr-1"></i>
          {{ getPrinterInfoText() }}
        </div>
      </div>
    </div>

    <!-- Footer con botones de acción -->
    <div class="packaging-modal-footer bg-gray-50 px-4 lg:px-6 py-3 lg:py-4 border-t border-gray-200 flex-shrink-0">
      <p class="text-xs text-gray-500 mb-2 hidden sm:block">
        <i class="fas fa-info-circle mr-1"></i>
        Revisa todos los repuestos antes de confirmar
      </p>
      <div class="packaging-modal-footer-actions flex gap-2">
        <button (click)="cancelPackagePackaging()"
          class="bg-gray-500 hover:bg-gray-600 text-white px-3 lg:px-6 py-2 rounded-lg transition-colors text-sm">
          <i class="fas fa-times mr-1 lg:mr-2"></i>
          <span class="hidden sm:inline">Cancelar</span>
          <span class="sm:hidden">Salir</span>
        </button>
        <button (click)="printPackageLabelsDuringPackaging()"
          [disabled]="loadingPackageDetails || packageSparePartsToConfirm.length === 0"
          class="bg-green-600 hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-3 lg:px-6 py-2 rounded-lg transition-colors text-sm flex-1">
          <i class="fas fa-print mr-1 lg:mr-2"></i>
          Imprimir
        </button>
        <button (click)="confirmPackagePackaging()"
          [disabled]="loadingPackageDetails || packageSparePartsToConfirm.length === 0 || !selectedPackager || hasPackagingConfirmationBlock()"
          class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-3 lg:px-6 py-2 rounded-lg transition-colors text-sm flex-1">
          <i class="fas fa-box-check mr-1 lg:mr-2"></i>
          Confirmar
        </button>
      </div>
    </div>

  </div>
</div>

<!-- Modal de Reimpresión de Etiqueta -->
<div *ngIf="showReprintModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-semibold">Reimprimir Etiqueta</h2>
      <button (click)="closeReprintModal()" class="text-gray-500 hover:text-gray-700">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="mb-6">
      <p class="text-gray-700 mb-4">
        Reimprimir etiqueta para el paquete: <strong>{{ reprintPackageData?.packageNumber }}</strong>
      </p>

      <!-- Configuración de Impresión para Reimpresión -->
      <div class="bg-gray-50 rounded-lg p-4">
        <h3 class="text-sm font-medium text-gray-700 mb-3">Configuración de Impresión:</h3>

        <div class="space-y-3">
          <!-- Tipo de Impresora -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Tipo de Impresora</label>
            <div class="flex space-x-4">
              <label class="flex items-center">
                <input type="radio" [(ngModel)]="reprintPrinterType" value="paper"
                  class="mr-2 text-blue-600 focus:ring-blue-500">
                <span class="text-sm text-gray-700">Papel A4</span>
              </label>
              <label class="flex items-center">
                <input type="radio" [(ngModel)]="reprintPrinterType" value="thermal"
                  class="mr-2 text-blue-600 focus:ring-blue-500">
                <span class="text-sm text-gray-700">Ticketera Térmica</span>
              </label>
            </div>
          </div>

          <!-- Ancho de Ticketera (solo visible si es térmica) -->
          <div *ngIf="reprintPrinterType === 'thermal'">
            <label class="block text-sm font-medium text-gray-700 mb-2">Dimensiones de Ticketera</label>
            <select [(ngModel)]="reprintThermalPrinterWidth"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500">
              <option value="58mm">58mm x 100mm</option>
              <option value="80mm">80mm x 100mm</option>
              <option value="100mm">100mm x 150mm</option>
            </select>
          </div>

          <!-- Información del tipo seleccionado -->
          <div class="text-xs text-blue-600 bg-blue-50 p-2 rounded">
            <i class="fas fa-info-circle mr-1"></i>
            {{ getReprintPrinterInfoText() }}
          </div>
        </div>
      </div>
    </div>

    <div class="flex gap-3">
      <button type="button" (click)="closeReprintModal()"
        class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
        Cancelar
      </button>
      <button (click)="confirmReprintPackageLabel()" [disabled]="loading"
        class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
        <i class="fas fa-print mr-2"></i>
        {{ loading ? 'Imprimiendo...' : 'Reimprimir' }}
      </button>
    </div>
  </div>
</div>